(function ($) {
  'use strict';

  /**
   * Main Site Scripts
   * ===
   */


  /**
   * Accordion Controls
   */

  $('.js-accordion').each(function () {
    $(this).accordionControls();
  });


  /**
   * Click Thru Links
   */

  $('[data-thru-link]').clickThruLink({
    selector: '[data-thru-link]',
  });


  /**
   * External Links, Add Class
   */

  const links = document.querySelectorAll('a');
  links.forEach(link => {
    if (link.hostname !== window.location.hostname && link.hostname !== '') {
      link.classList.add('external-link');
    }
  });


  /**
   * Alerts & Announcements — Desktop Popover
   * Click the bell to toggle the panel; close on outside-click or Esc.
   */

  ( function() {
    var toggle = document.querySelector( '.js-alerts-toggle' );
    var panel  = document.getElementById( 'alerts-notifications-desktop' );

    if ( ! toggle || ! panel ) return;

    function openPanel() {
      panel.hidden = false;
      toggle.setAttribute( 'aria-expanded', 'true' );
      document.addEventListener( 'click', onOutside );
      document.addEventListener( 'keydown', onEsc );
    }

    function closePanel() {
      panel.hidden = true;
      toggle.setAttribute( 'aria-expanded', 'false' );
      document.removeEventListener( 'click', onOutside );
      document.removeEventListener( 'keydown', onEsc );
    }

    function onOutside( e ) {
      if ( ! panel.contains( e.target ) && ! toggle.contains( e.target ) ) {
        closePanel();
      }
    }

    function onEsc( e ) {
      if ( e.key === 'Escape' ) {
        closePanel();
        toggle.focus();
      }
    }

    toggle.addEventListener( 'click', function( e ) {
      e.stopPropagation();
      if ( toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
        closePanel();
      } else {
        openPanel();
      }
    } );
  } )();


  /**
   * Mega Menu, Overlay setup
   */

  function updateOverlay(megaMenu) {
    const bottom = megaMenu.getBoundingClientRect().bottom;
    const overlay = megaMenu.nextElementSibling;
    overlay.style.top = `${bottom}px`;
  }

  function updateOverlayBlur(megaMenu) {
    const overlayBlur = megaMenu.querySelector('.overlay-blur');
    if (!overlayBlur) return;

    const siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;

    const navMain = megaMenu.closest('.navigation--main');
    if (!navMain) return;

    const headerRect = siteHeader.getBoundingClientRect();
    const navRect = navMain.getBoundingClientRect();

    overlayBlur.style.left = `${headerRect.left - navRect.left}px`;
    overlayBlur.style.right = 'auto';
    overlayBlur.style.width = `${headerRect.width}px`;
    overlayBlur.style.height = `${megaMenu.getBoundingClientRect().height}px`;
    overlayBlur.style.marginLeft = '0';
    overlayBlur.style.marginRight = '0';
  }

  /**
   * Click-to-open disclosure (replaces the previous hover behaviour).
   *
   * Top-level items with children are neutralised into buttons at runtime:
   * the href moves to data-href and role/aria-expanded/tabindex are added.
   * The <a> ELEMENT IS DELIBERATELY KEPT rather than swapped for a real
   * <button> — every style rule in _navigation--main.scss keys off `a`
   * (the underline :before, the global .navigation--main a type rule, the
   * chevron :after, and the .theme-national-air-cargo / .theme-go-national
   * overrides), so a tag swap would mean rewriting all of them for no
   * user-visible gain. Role and aria-expanded are what assistive tech
   * actually reads, and both are correct here.
   *
   * The parent page stays reachable via the overview card / links inside
   * each mega menu — menu items are intentionally left as Page items in the
   * WP menu (not custom links) so current-menu-ancestor still resolves, and
   * so a failed script load degrades to a working link rather than a dead nav.
   */

  let activeMegaMenu = null;
  let closeActiveMenu = null; // closer belonging to whichever item is open

  document.querySelectorAll('.navigation--main .menu-item-has-children').forEach((item, index) => {
    const megaMenu = item.querySelector('.mega-menu');
    const toggle = item.querySelector(':scope > a');
    if (!megaMenu || !toggle) return;

    const overlay = megaMenu.nextElementSibling; // .mega-menu-overlay

    // The partials emit no id, so mint one for aria-controls rather than
    // editing all eight mega menu templates.
    if (!megaMenu.id) {
      megaMenu.id = `mega-menu-${index + 1}`;
    }

    if (toggle.hasAttribute('href')) {
      toggle.dataset.href = toggle.getAttribute('href');
      toggle.removeAttribute('href');
    }
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', megaMenu.id);

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    function openMenu() {
      if (closeActiveMenu) closeActiveMenu(); // only one open at a time
      activeMegaMenu = megaMenu;
      closeActiveMenu = closeMenu;
      item.classList.add('is-mega-active');
      toggle.setAttribute('aria-expanded', 'true');
      updateOverlay(megaMenu);
      updateOverlayBlur(megaMenu);
    }

    function closeMenu() {
      if (activeMegaMenu === megaMenu) activeMegaMenu = null;
      if (closeActiveMenu === closeMenu) closeActiveMenu = null;
      item.classList.remove('is-mega-active');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function toggleMenu() {
      if (isOpen()) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    toggle.addEventListener('click', e => {
      e.preventDefault();
      toggleMenu();
    });

    // href is gone, so Enter no longer activates natively — and Space never
    // did on an anchor.
    toggle.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggleMenu();
      }
    });

    item.addEventListener('keydown', e => {
      if (e.key === 'Escape' && isOpen()) {
        closeMenu();
        toggle.focus();
      }
    });

    // Keyboard exit: stops a menu hanging open behind the next top-level item.
    // relatedTarget is null on mouse-driven blur to a non-focusable area —
    // those are left to the outside-click handler so that clicking dead space
    // inside an open mega menu doesn't yank it closed mid-interaction.
    item.addEventListener('focusout', e => {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) closeMenu();
    });

    if (overlay?.classList.contains('mega-menu-overlay')) {
      overlay.addEventListener('click', closeMenu);
    }
  });

  document.addEventListener('click', e => {
    if (!closeActiveMenu) return;
    if (!e.target.closest('.navigation--main .menu-item-has-children.is-mega-active')) {
      closeActiveMenu();
    }
  });

  window.addEventListener('resize', () => {
    if (activeMegaMenu) {
      updateOverlay(activeMegaMenu);
      updateOverlayBlur(activeMegaMenu);
    }
  });

  /**
   * Scrolling past the panel closes it.
   *
   * The hover version closed itself implicitly — scrolling moved the pointer
   * off the menu. On click the panel stays open, and the page dim is
   * .overlay-blur:after: a 100vh block anchored to the panel's bottom edge, so
   * it has a hard bottom edge one viewport below the panel. Scroll far enough
   * and that seam comes into view over undimmed content (which is the reported
   * bug), and the panel itself sits open off-screen.
   *
   * The trigger is the panel's bottom clearing the top of the viewport. At that
   * exact moment the bottom of the dim is level with the bottom of the
   * viewport, so the seam is never visible.
   *
   * Only closes on the way past — no reopen on scroll back up, matching the
   * click-to-open contract.
   */
  window.addEventListener('scroll', () => {
    if (!activeMegaMenu || !closeActiveMenu) return;
    if (activeMegaMenu.getBoundingClientRect().bottom <= 0) closeActiveMenu();
  }, { passive: true });


  // waypoints, animate clouds

  $('.section-cloud').each(function() {
    var $el = $(this);

    $el.waypoint(function(direction) {
      if (direction === 'down') {
        $el.addClass('animate');
      } else {
        $el.removeClass('animate');
      }
    }, {
      offset: '75%'
    });
  });
  

  /**
   * SEO - Delete empty header & footer els from sections
   */

  $('.is-header-disabled').find('> .section-header').remove();
  $('.is-footer-disabled').find('> .section-footer').remove();


  /**
   * YouTube Facade
   * Swaps the static thumbnail + play button (rendered server-side via
   * labkit_render_youtube_facade()) for a real YouTube iframe on click.
   * Avoids letting YouTube's own embed poster — sometimes only available at
   * a low resolution — get stretched by the native player to fill a large
   * hero container.
   */

  document.querySelectorAll( '.youtube-facade' ).forEach( function( facade ) {
    var videoId = facade.dataset.videoId;
    if ( ! videoId ) return;

    var thumb = facade.querySelector( '.youtube-facade-thumb' );

    // Not every video has a maxresdefault.jpg — fall back to hqdefault.jpg
    if ( thumb ) {
      thumb.addEventListener( 'error', function() {
        if ( thumb.dataset.fallback ) {
          thumb.src = thumb.dataset.fallback;
        }
      }, { once: true } );
    }

    facade.addEventListener( 'click', function() {
      var playBtn = facade.querySelector( '.youtube-facade-play' );
      var iframe  = document.createElement( 'iframe' );

      iframe.src             = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1';
      iframe.title           = playBtn ? playBtn.getAttribute( 'aria-label' ) : 'YouTube video';
      iframe.frameBorder     = '0';
      iframe.allow           = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      facade.replaceWith( iframe );
    } );
  } );


  /**
   * Sticky Header + Link Bar
   * ─────────────────────────────────────────────────────────────────────────
   * STICKY_MODE controls trigger behaviour:
   *   'scroll-up' — elements appear only while scrolling upward (current brief)
   *   'always'    — standard always-on sticky (one-line change if needed later)
   */

  ( function() {

    var STICKY_MODE = 'scroll-up';

    // Minimum continuous upward travel, in px, before anything pins.
    //
    // Without this the trigger was a bare `scrollY < lastScrollY`, so a single
    // pixel of upward movement pinned both elements — client QA 8/19 called it
    // "the aggressive scroll pop in when scrolling 1 pixel up" and asked that
    // it "consider further scroll up" (issue #303). The accumulator resets on
    // any downward movement, so the threshold has to be cleared in one gesture
    // rather than accumulated across a jittery trackpad scroll.
    var STICKY_UP_THRESHOLD = 200;

    // Same idea in the other direction, for the link bar. The two elements are
    // mutually exclusive: the header pins on upward travel, the link bar pins on
    // downward travel, and each release cancels the other. Between the two
    // thresholds neither state changes, so a direction reversal produces a short
    // window with nothing pinned rather than a flicker of both.
    var STICKY_DOWN_THRESHOLD = 80;

    // Gap between the viewport edge and a pinned element, in px. Must match the
    // 17px left / right inset in _site-header.scss and link-bar/style.scss, and
    // the link bar's in-flow `margin: 17px` — that's what gives both bars the
    // floating look and keeps the pinned geometry identical to the in-flow one.
    var STICKY_INSET = 17;

    var siteHeader = document.querySelector( '.site-header' );
    var linkBar    = document.querySelector( '.link-bar' );

    if ( ! siteHeader ) return;

    var lastScrollY         = window.scrollY;
    var headerNaturalBottom = 0;
    var linkBarNaturalTop   = 0;
    var headerPlaceholder   = null;
    var linkBarPlaceholder  = null;
    var isHeaderSticky      = false;
    var isLinkBarSticky     = false;
    var upwardTravel        = 0;
    var downwardTravel      = 0;

    // Cached measurements — read from the DOM only in measure() and on resize,
    // never inside the scroll handler to avoid layout thrashing.
    var adminBarHeight = 0;
    var headerHeight   = 0;

    // Measure and cache all layout values that the scroll handler needs.
    // Called on window load (not DOMContentLoaded) so image heights are settled.
    function measure() {
      var adminBar   = document.getElementById( 'wpadminbar' );
      adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
      headerHeight   = siteHeader.offsetHeight;

      if ( ! isHeaderSticky ) {
        headerNaturalBottom = siteHeader.getBoundingClientRect().bottom + window.scrollY;
      }
      if ( linkBar && ! isLinkBarSticky ) {
        linkBarNaturalTop = linkBar.getBoundingClientRect().top + window.scrollY;
      }
    }


    function setHeaderSticky( sticky ) {
      if ( sticky === isHeaderSticky ) return;
      isHeaderSticky = sticky;

      if ( sticky ) {
        // Re-read offsetHeight right before pinning — header is still in normal
        // flow at this point so the value is accurate, and this only fires on
        // the infrequent sticky transition rather than every scroll event.
        headerHeight = siteHeader.offsetHeight;
        headerPlaceholder = document.createElement( 'div' );
        headerPlaceholder.style.height = headerHeight + 'px';
        headerPlaceholder.setAttribute( 'aria-hidden', 'true' );
        siteHeader.after( headerPlaceholder );
        siteHeader.style.top = ( adminBarHeight + STICKY_INSET ) + 'px';
        siteHeader.classList.add( 'is-sticky' );
      } else {
        siteHeader.classList.remove( 'is-sticky' );
        siteHeader.style.top = '';
        if ( headerPlaceholder ) {
          headerPlaceholder.remove();
          headerPlaceholder = null;
        }
      }
    }

    function setLinkBarSticky( sticky ) {
      if ( ! linkBar || sticky === isLinkBarSticky ) return;
      isLinkBarSticky = sticky;

      if ( sticky ) {
        // Read the header's bottom edge directly — single DOM read at transition
        // time only, not on every scroll event. Eliminates height-calculation drift.
        //
        // Only valid while the header is pinned. When the link bar pins on the
        // way DOWN the header has been released and has scrolled off, so its
        // bottom edge is negative — reading it there put the bar off-screen.
        // Fall back to the admin bar offset in that case, which is where the
        // top of the viewport actually is.
        var headerBottom = isHeaderSticky
          ? siteHeader.getBoundingClientRect().bottom
          : adminBarHeight;
        linkBarPlaceholder = document.createElement( 'div' );
        linkBarPlaceholder.style.height = ( linkBar.offsetHeight + STICKY_INSET ) + 'px';
        linkBarPlaceholder.setAttribute( 'aria-hidden', 'true' );
        linkBar.after( linkBarPlaceholder );
        linkBar.classList.add( 'is-sticky' );
        // The inset matches the bar's in-flow `margin-top: 17px` and the 17px
        // left / right inset in .link-bar.is-sticky, so the gap is the same
        // pinned as it is in flow. Was flush against the header before.
        linkBar.style.top = ( headerBottom + STICKY_INSET ) + 'px';
      } else {
        linkBar.classList.remove( 'is-sticky' );
        linkBar.style.top = '';
        if ( linkBarPlaceholder ) {
          linkBarPlaceholder.remove();
          linkBarPlaceholder = null;
        }
      }
    }

    function onScroll() {
      var scrollY     = window.scrollY;

      // Mid programmatic scroll — track position, but don't act on it.
      if ( Date.now() < suppressStickyUntil ) {
        lastScrollY = scrollY;
        return;
      }

      var delta   = scrollY - lastScrollY;
      lastScrollY = scrollY;

      // Accumulate travel in each direction; movement the other way starts the
      // opposite accumulator over.
      // delta === 0 is left alone so a no-op scroll event doesn't reset either.
      if ( delta < 0 ) {
        upwardTravel -= delta;
        downwardTravel = 0;
      } else if ( delta > 0 ) {
        downwardTravel += delta;
        upwardTravel = 0;
      }

      var scrollingUp   = upwardTravel   >= STICKY_UP_THRESHOLD;
      var scrollingDown = downwardTravel >= STICKY_DOWN_THRESHOLD;

      if ( STICKY_MODE === 'always' ) {
        setHeaderSticky( scrollY > headerNaturalBottom );
        if ( linkBar ) setLinkBarSticky( scrollY > linkBarNaturalTop );
      } else {
        // Directional swap. Scrolling up shows the header, scrolling down shows
        // the link bar, never both. The release always runs before the pin so
        // that setLinkBarSticky() reads a settled isHeaderSticky when it works
        // out its own top offset.
        if ( scrollingUp ) {
          setLinkBarSticky( false );
          // Header: sticky while above its natural position
          setHeaderSticky( scrollY > headerNaturalBottom );
        } else if ( scrollingDown ) {
          setHeaderSticky( false );
          // Link bar: sticky once past its natural position; releases back into
          // flow when we scroll back up to it.
          setLinkBarSticky( scrollY > linkBarNaturalTop );
        }
        // Neither threshold cleared — hold the current state.
      }
    }

    // Programmatic scroll suppression
    // ───────────────────────────────────────────────────────────────────────
    // Add Stop / Add Item scroll the new clone into view, and the clone is
    // inserted ABOVE the button that was just clicked — so that scroll moves the
    // page upward. In 'scroll-up' mode the handler reads that as user intent and
    // pins the header, which lands it over the hero mid-page. Same class of bug
    // as GF's post-validation scroll (see formPageResetScroll).
    //
    // Callers wrap a programmatic scroll with window.labKitSuppressSticky( ms ):
    // the header is released and the scroll handler ignores events until the
    // smooth scroll has settled. Real user scrolls afterwards behave normally.
    var suppressStickyUntil = 0;

    window.labKitSuppressSticky = function( ms ) {
      suppressStickyUntil = Date.now() + ( ms || 1000 );
      teardown();
    };

    function isMobile() {
      return window.innerWidth < 760;
    }

    function teardown() {
      setHeaderSticky( false );
      setLinkBarSticky( false );
      // Clear the accumulator too, or a primed value survives the teardown and
      // re-pins on the first upward pixel afterwards.
      upwardTravel   = 0;
      downwardTravel = 0;
    }

    window.addEventListener( 'load', function() {
      if ( ! isMobile() ) measure();
    } );
    window.addEventListener( 'scroll', function() {
      if ( ! isMobile() ) onScroll();
    }, { passive: true } );
    window.addEventListener( 'resize', function() {
      if ( isMobile() ) {
        teardown();
        return;
      }
      measure();
      if ( isHeaderSticky ) siteHeader.style.top = ( adminBarHeight + STICKY_INSET ) + 'px';
    } );

  } )();


  /* Gravity Forms, tooltips setups */

  function initCharterCards(context) {
    context = context || document;
    const groups = context.querySelectorAll('.service-type-field, .cargo-transportation-type-field, .priority-type-field, .packing-type-field');
    groups.forEach(function(group) {
      const choices = group.querySelectorAll('.gchoice');
      choices.forEach(function(choice) {
        const radio = choice.querySelector('input[type="radio"]');
        const label = choice.querySelector('.gform-field-label');
        if (!radio || !label) return;
        // Remove radio from tab order, make label focusable instead
        radio.setAttribute('tabindex', '-1');
        label.setAttribute('tabindex', '0');
        // Space and Enter select the card
        const input = choice.querySelector( 'input[type="radio"], input[type="checkbox"]' );

        label.addEventListener( 'keydown', function( e ) {
            if ( e.target.closest( '.charter-card__tip-btn' ) ) return;
            if ( e.key === ' ' || e.key === 'Enter' ) {
                e.preventDefault();
                if ( input.type === 'checkbox' ) {
                    input.checked = ! input.checked; // toggle
                } else {
                    input.checked = true; // radio always selects
                }
                input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
            }
        } );
      });
    });
    const tipBtns = context.querySelectorAll('.charter-card__tip-btn');
    tipBtns.forEach(attachTooltipBehavior);
  }


  // Tooltip behaviour

  function attachTooltipBehavior( btn ) {
    btn.addEventListener( 'click', function ( e ) {
      // Stop the click reaching the <label> — prevents unintended radio selection
      e.stopPropagation();
      e.preventDefault();

      const isOpen   = btn.getAttribute( 'aria-expanded' ) === 'true';
      const bubbleId = btn.getAttribute( 'aria-controls' );
      const bubble   = bubbleId ? document.getElementById( bubbleId ) : null;

      if ( ! bubble ) return;

      if ( isOpen ) {
        closeTooltip( btn, bubble );
      } else {
        closeAllTooltips();     // close any others first
        openTooltip( btn, bubble );
      }
    } );
  }

  function openTooltip( btn, bubble ) {
    bubble.removeAttribute( 'hidden' );
    btn.setAttribute( 'aria-expanded', 'true' );

    positionFieldTip( bubble );

    // Close when clicking outside
    document.addEventListener( 'click', onOutsideClick );
    // Close on Escape
    document.addEventListener( 'keydown', onEscapeKey );
  }

  /**
   * Field-label tooltip edge clamping
   *
   * The bubble is centred on its icon in CSS, which overflows the viewport when
   * the icon sits near either edge. CSS can't detect that, so the horizontal
   * correction is measured here and handed to CSS as --tip-shift: the bubble is
   * translated by that amount while the arrow subtracts it back out, so the box
   * moves and the arrow stays centred over the icon.
   *
   * Only applies to .field-tip__bubble. The card tooltips use fixed per-breakpoint
   * offsets and are left untouched.
   */

  var FIELD_TIP_EDGE_PAD = 16;   // min gap between bubble and viewport edge
  var FIELD_TIP_ARROW_INSET = 20; // keeps the arrow clear of the rounded corners

  function positionFieldTip( bubble ) {
    if ( ! bubble || ! bubble.classList.contains( 'field-tip__bubble' ) ) return;

    // Measure from the unshifted position, or each call compounds the last.
    bubble.style.setProperty( '--tip-shift', '0px' );

    var rect  = bubble.getBoundingClientRect();
    var vw    = window.innerWidth || document.documentElement.clientWidth;
    var shift = 0;

    if ( rect.left < FIELD_TIP_EDGE_PAD ) {
      shift = FIELD_TIP_EDGE_PAD - rect.left;
    } else if ( rect.right > vw - FIELD_TIP_EDGE_PAD ) {
      shift = ( vw - FIELD_TIP_EDGE_PAD ) - rect.right;
    }

    // Never shift so far that the arrow leaves the bubble.
    var maxShift = Math.max( 0, ( rect.width / 2 ) - FIELD_TIP_ARROW_INSET );
    shift = Math.max( -maxShift, Math.min( maxShift, shift ) );

    bubble.style.setProperty( '--tip-shift', Math.round( shift ) + 'px' );
  }

  // Re-measure any open field tip when the viewport changes width.
  window.addEventListener( 'resize', function() {
    document.querySelectorAll( '.field-tip__bubble:not([hidden])' ).forEach( positionFieldTip );
  } );

  function closeTooltip( btn, bubble ) {
    bubble.setAttribute( 'hidden', '' );
    btn.setAttribute( 'aria-expanded', 'false' );

    document.removeEventListener( 'click', onOutsideClick );
    document.removeEventListener( 'keydown', onEscapeKey );
  }

  function closeAllTooltips() {
    document.querySelectorAll( '.charter-card__tip-btn[aria-expanded="true"]' ).forEach( function ( openBtn ) {
      const bubbleId = openBtn.getAttribute( 'aria-controls' );
      const bubble   = bubbleId ? document.getElementById( bubbleId ) : null;
      if ( bubble ) closeTooltip( openBtn, bubble );
    } );
  }

  function onOutsideClick( e ) {
    if ( ! e.target.closest( '.charter-card__tip-btn' ) ) {
      closeAllTooltips();
    }
  }

  function onEscapeKey( e ) {
    if ( e.key === 'Escape' ) {
      closeAllTooltips();
    }
  }


  /**
  * Number Stepper
  * Targets any number input inside a .gfield with .item-count-field
  */

  function initNumberSteppers( context ) {
      context = context || document;

      context.querySelectorAll( '.item-count-field input[type="number"]' ).forEach( function( input ) {

          // Prevent double-init
          if ( input.closest( '.number-stepper' ) ) return;

          const min  = parseFloat( input.min )  || 0;
          const step = parseFloat( input.step ) || 1;

          // Set a sensible default value if empty
          if ( input.value === '' ) input.value = min;

          // Wrap the input
          const wrapper = document.createElement( 'div' );
          wrapper.className = 'number-stepper';
          input.parentNode.insertBefore( wrapper, input );
          wrapper.appendChild( input );

          // Minus button
          const minusBtn = document.createElement( 'button' );
          minusBtn.type = 'button';
          minusBtn.className = 'stepper-btn stepper-btn--minus';
          minusBtn.setAttribute( 'aria-label', 'Decrease ' + ( input.getAttribute( 'aria-label' ) || 'value' ) );
          minusBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM6.5625 9.0625H13.4375C13.957 9.0625 14.375 9.48047 14.375 10C14.375 10.5195 13.957 10.9375 13.4375 10.9375H6.5625C6.04297 10.9375 5.625 10.5195 5.625 10C5.625 9.48047 6.04297 9.0625 6.5625 9.0625Z" fill="currentColor"/></svg>';

          // Plus button
          const plusBtn = document.createElement( 'button' );
          plusBtn.type = 'button';
          plusBtn.className = 'stepper-btn stepper-btn--plus';
          plusBtn.setAttribute( 'aria-label', 'Increase ' + ( input.getAttribute( 'aria-label' ) || 'value' ) );
          plusBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM9.0625 13.4375V10.9375H6.5625C6.04297 10.9375 5.625 10.5195 5.625 10C5.625 9.48047 6.04297 9.0625 6.5625 9.0625H9.0625V6.5625C9.0625 6.04297 9.48047 5.625 10 5.625C10.5195 5.625 10.9375 6.04297 10.9375 6.5625V9.0625H13.4375C13.957 9.0625 14.375 9.48047 14.375 10C14.375 10.5195 13.957 10.9375 13.4375 10.9375H10.9375V13.4375C10.9375 13.957 10.5195 14.375 10 14.375C9.48047 14.375 9.0625 13.957 9.0625 13.4375Z" fill="currentColor"/></svg>';

          wrapper.insertBefore( minusBtn, input );
          wrapper.appendChild( plusBtn );

          function updateButtons() {
              minusBtn.disabled = parseFloat( input.value ) <= min;
          }

          minusBtn.addEventListener( 'click', function() {
              const current = parseFloat( input.value ) || min;
              const next    = Math.max( min, current - step );
              input.value   = next;
              input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
              updateButtons();
          } );

          plusBtn.addEventListener( 'click', function() {
              const current = parseFloat( input.value ) || min;
              input.value   = current + step;
              input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
              updateButtons();
          } );

          // Validate on manual input
          input.addEventListener( 'change', updateButtons );
          input.addEventListener( 'input', updateButtons );

          updateButtons();
      } );
  }

  // Gravity Forms, getting .form-section added with html fields to work with conditional logic

  /**
  * Charter Payload Units
  * Updates unit labels on Total Weight, Total Volume, and Net Quantity per Item
  * based on the Imperial/Metric toggle and the active Weight/Volume Measurement dropdown.
  *
  * - Weight and Volume labels are handled purely by SCSS via [data-unit-system] on
  *   the .form-section (set by initUnitToggle).
  * - Net Quantity unit is dynamic: JS reads the active measurement dropdown,
  *   maps the selection to a short abbreviation, and sets a --net-qty-unit CSS
  *   custom property on the field element. SCSS uses content: var(--net-qty-unit)
  *   on the child .ginput_container::after — CSS vars inherit down, attr() doesn't.
  */
  function initCharterPayloadUnits( context ) {
      context = context || document;

      // Map dropdown option values → short unit abbreviations
      var UNIT_ABBR = {
          // Imperial dropdown
          'weight in ounces':       'oz',
          'weight in pounds':       'lbs',
          'volume in fluid ounces': 'fl oz',
          'volume in quarts':       'qt',
          'volumne in quarts':      'qt',   // typo in GF data
          // Metric dropdown
          'weight in kilograms':    'kg',
          'weight in grams':        'g',
          'volume in liters':       'L',
          'volume in milliliters':  'mL',
          'volumne in mililiters':  'mL',   // typo in GF data
      };

      function updateNetQtyUnit( $section ) {
          if ( ! $section || ! $section.length ) return;

          var unitSystem = $section.attr( 'data-unit-system' ) || 'imperial';
          var $dropdown  = unitSystem === 'metric'
              ? $section.find( '.metric-weight-volume-measurement select' )
              : $section.find( '.imperial-weight-volume-measurement select' );

          var abbr = UNIT_ABBR[ $dropdown.val() ] || 'oz';
          $section.find( '.charter-payload-net-quantity' ).each( function() {
              this.style.setProperty( '--net-qty-unit', '"' + abbr + '"' );
          } );
      }

      // Re-run when either measurement dropdown changes
      $( context )
          .find( '.imperial-weight-volume-measurement select, .metric-weight-volume-measurement select' )
          .off( 'change.charterpayloadunits' )
          .on(  'change.charterpayloadunits', function() {
              updateNetQtyUnit( $( this ).closest( '.form-section' ) );
          } );

      // Re-run when units toggle switches (active dropdown changes)
      $( context )
          .find( '.units-toggle-field input[type="radio"]' )
          .off( 'change.charterpayloadunits' )
          .on(  'change.charterpayloadunits', function() {
              // Defer slightly so initUnitToggle has updated data-unit-system first
              var $section = $( this ).closest( '.form-section' );
              setTimeout( function() { updateNetQtyUnit( $section ); }, 0 );
          } );

      // Seed on init
      $( context ).find( '.charter-payload-net-quantity' ).each( function() {
          updateNetQtyUnit( $( this ).closest( '.form-section' ) );
      } );
  }

  /**
  * Passenger → Estimated Total Payload auto-calculation
  * When passenger count changes, auto-fills payload at (passengers × 250)
  * unless the user has manually overridden the payload field.
  * Clearing the payload field resets it back to auto-fill mode.
  */
  function initPassengerPayloadCalc( context ) {
      context = context || document;

      $( context ).find( '.estimated-total-payload' ).each( function() {
          var $payloadField   = $( this );
          var $payloadInput   = $payloadField.find( 'input[type="number"]' );
          var $passengerInput = $payloadField.closest( '.form-section' )
                                             .find( '.item-count-field input[type="number"]' );

          if ( ! $passengerInput.length || ! $payloadInput.length ) return;

          function calcPayload() {
              if ( $payloadInput.data( 'user-modified' ) ) return;
              var count = parseInt( $passengerInput.val(), 10 );
              $payloadInput.val( count > 0 ? count * 250 : '' );
          }

          // Listen for stepper clicks (change) and direct keyboard input
          $passengerInput
              .off( 'input.estpayload change.estpayload' )
              .on(  'input.estpayload change.estpayload', calcPayload );

          // Track manual edits on the payload field
          $payloadInput
              .off( 'input.estpayload' )
              .on(  'input.estpayload', function() {
                  var count      = parseInt( $passengerInput.val(), 10 ) || 0;
                  var autoVal    = count * 250;
                  var currentVal = parseInt( $( this ).val(), 10 );

                  // Empty or matches auto value → release manual lock
                  if ( $( this ).val() === '' || currentVal === autoVal ) {
                      $( this ).removeData( 'user-modified' );
                  } else {
                      $( this ).data( 'user-modified', true );
                  }
              } );

          // Seed value on init if passenger count is already set
          calcPayload();
      } );
  }

  /**
   * Scroll A Cloned Block Into View
   *
   * .site-main is position:relative / overflow:hidden, which makes it a scroll
   * CONTAINER even though it never shows a scrollbar. Element.scrollIntoView()
   * scrolls every scrollable ancestor, not just the window -- so Add Stop /
   * Add Item silently set .site-main.scrollTop. All page content then sits that
   * many pixels higher, sliding the hero up behind the header, and because the
   * container has no scrollbar and receives no wheel events there is no way to
   * put it back. Only a reload cleared it.
   *
   * Related but NOT the same as the 8/7 validation-scroll fix below
   * (formPageResetScroll). GF's post-validation scroll moves the window, so
   * re-scrolling the window undid it. An ancestor container scroll survives
   * window.scrollTo entirely.
   *
   * So: zero any ancestor that has already been scrolled, then scroll the
   * window explicitly. Do NOT swap this back to scrollIntoView.
   */
  function scrollCloneIntoView( el ) {
      if ( ! el ) return;

      // Reset ancestor container scroll first -- this changes the element's
      // rect, so it has to happen before the measurement below. Stops at body:
      // documentElement.scrollTop IS the window scroll and must not be touched.
      var node = el.parentNode;
      while ( node && node.nodeType === 1 && node !== document.body ) {
          if ( node.scrollTop ) node.scrollTop = 0;
          node = node.parentNode;
      }

      var header = document.querySelector( '.site-header' );
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top    = el.getBoundingClientRect().top + window.pageYOffset - offset - 16;

      if ( window.labKitSuppressSticky ) window.labKitSuppressSticky();
      window.scrollTo( { top: Math.max( top, 0 ), behavior: 'smooth' } );
  }

  function updateSectionVisibility() {
    document.querySelectorAll( '.form-section' ).forEach( function( section ) {
        var allFields = section.querySelectorAll(
            '.gfield:not(.gfield--type-section):not(.gfield--type-html):not(.spacer)'
        );

        // Exclude fields inside cloned blocks — GF's conditional logic only
        // knows about the original (data-stop="1" / data-item="1") fields.
        // Cloned fields with modified IDs are always visible from GF's perspective,
        // so including them would prevent sections from ever hiding correctly.
        //
        // Also exclude the Service Path mirror (see initServicePathMirror). It is
        // hidden by a CSS class, not by an inline display:none or .gfield_hidden,
        // so the allHidden test below reads it as VISIBLE and its section could
        // never hide. It is a logic-only field and should never count toward
        // whether a section has visible content.
        //
        // Same for admin-Hidden fields (.gfield_visibility_hidden), e.g. the
        // repeatable-block JSON textareas 161/162/163. GF hides them off-screen,
        // not with display:none, so they were holding sections open
        // (found 2026-10-02).
        var fields = Array.from( allFields ).filter( function( field ) {
            return ! field.closest( '.multi-stop-block:not([data-stop="1"])' ) &&
                   ! field.closest( '.freight-item-block:not([data-item="1"])' ) &&
                   ! field.closest( '.customs-item-block:not([data-item="1"])' ) &&
                   ! field.closest( '.service-path-mirror' ) &&
                   ! field.classList.contains( 'gfield_visibility_hidden' );
        } );

        if ( ! fields.length ) return;

        var allHidden = fields.every( function( field ) {
            return field.style.display === 'none' || field.classList.contains( 'gfield_hidden' );
        } );

        if ( allHidden ) {
            // Remove clones before hiding — orphaned clones would reappear
            // the next time the section becomes visible.
            section.querySelectorAll(
                '.multi-stop-block:not([data-stop="1"]), ' +
                '.freight-item-block:not([data-item="1"]), ' +
                '.customs-item-block:not([data-item="1"])'
            ).forEach( function( block ) { block.remove(); } );
        }

        section.style.display = allHidden ? 'none' : '';
    } );

    // Two-col layout visibility, hide layout if all interactive fields inside are hidden
    document.querySelectorAll( '.gf-two-col-layout' ).forEach( function( layout ) {
        const fields = layout.querySelectorAll(
            '.gfield:not(.gfield--type-html):not(.spacer)'
        );

        if ( ! fields.length ) return;

        const allHidden = Array.from( fields ).every( function( field ) {
            return field.style.display === 'none' || field.classList.contains( 'gfield_hidden' );
        } );

        if ( allHidden ) {
            layout.style.setProperty( 'display', 'none', 'important' );
        } else {
            layout.style.removeProperty( 'display' );
        }
    } );

    // Custom field-group wrappers — hide when all child gfields are GF-hidden
    document.querySelectorAll(
        '.total-cargo-weight-and-volume, .dimension-fields-wrap'
    ).forEach( function( wrap ) {
        var fields = Array.from( wrap.querySelectorAll( '.gfield' ) );
        if ( ! fields.length ) return;

        var allHidden = fields.every( function( field ) {
            return field.style.display === 'none' || field.classList.contains( 'gfield_hidden' );
        } );

        wrap.style.display = allHidden ? 'none' : '';
    } );
  }


  // Wrapping Form Fields

  function initDimensionFieldsWrap( context ) {
    var processed = [];

    $( context ).find( '.imperial-dimension.item-dimension-field' ).each( function() {
        var $field = $( this );

        // Skip if already wrapped or already processed
        if ( $field.parent().hasClass( 'dimension-fields-wrap' ) ) return;
        if ( processed.indexOf( this ) !== -1 ) return;

        // Find contiguous siblings
        var $next1 = $field.next( '.imperial-dimension' );
        var $next2 = $next1.next( '.imperial-dimension' );
        var $group = $field.add( $next1 ).add( $next2 );

        // Track processed fields
        $group.each( function() { processed.push( this ); } );

        $group.wrapAll( '<div class="dimension-fields-wrap"></div>' );
    } );
  }

  function initWeightVolumeWrap( context ) {
    $( context ).find( '.cargo-weight-field' ).each( function() {
        var $weight = $( this );

        // Skip if already wrapped
        if ( $weight.parent().hasClass( 'total-cargo-weight-and-volume' ) ) return;

        var $volume = $weight.next( '.cargo-volume-field' );
        if ( ! $volume.length ) return;

        $weight.add( $volume ).wrapAll( '<div class="total-cargo-weight-and-volume"></div>' );
    } );
  }

  function initItemCountPlusWeightWrap( context ) {
    var processed = [];

    $( context ).find( '.item-count-plus-weight' ).each( function() {
        var $field = $( this );

        // Skip if already wrapped
        if ( $field.parent().hasClass( 'item-count-plus-weight-wrap' ) ) return;
        if ( processed.indexOf( this ) !== -1 ) return;

        // Find siblings
        var $next1 = $field.next( '.item-count-plus-weight' );
        var $next2 = $next1.next( '.item-count-plus-weight' );
        var $group = $field.add( $next1 ).add( $next2 );

        $group.each( function() { processed.push( this ); } );

        $group.wrapAll( '<div class="item-count-plus-weight-wrap"></div>' );
    } );
  }

  /* Net quantity + Weight/Volume Measurement (hazmat / DG fields)
   *
   * WHY THIS EXISTS: wrapFreightItemBlock() calls wrapAll() to move the item
   * fields into a plain <div class="freight-item-block">. That makes them stop
   * being direct children of GF's .gform_fields grid, so layoutGridColumnSpan
   * silently goes inert INSIDE the block -- which is why these three fields lay
   * out correctly on NAL (not in a block) and stack full-width on NAC despite
   * having identical classes and identical grid spans.
   *
   * SCOPED TO .freight-item-block deliberately. NAL has the same three field
   * classes at form level where GF's grid still works; wrapping those would
   * regress NAL's layout.
   *
   * Both measurement selects are included. They are mutually exclusive via GF
   * conditional logic, and the hidden one is display:none so it occupies no
   * space in the flex row.
   *
   * No re-init needed after cloning: addFreightItem() clones the DOM, so the
   * wrapper comes with it. The parent-class guard covers a re-run either way. */
  function initNetQuantityMeasurementWrap( context ) {
    $( context ).find( '.freight-item-block .charter-payload-net-quantity' ).each( function() {
        var $field = $( this );

        // Skip if already wrapped
        if ( $field.parent().hasClass( 'net-quantity-measurement-wrap' ) ) return;

        var MEASURE = '.metric-weight-volume-measurement, .imperial-weight-volume-measurement';
        var $next1  = $field.next( MEASURE );
        var $next2  = $next1.next( MEASURE );

        // Nothing to pair with -- leave the field alone rather than wrapping it
        // on its own, which would change its layout for no reason.
        if ( ! $next1.length ) return;

        $field.add( $next1 ).add( $next2 )
              .wrapAll( '<div class="net-quantity-measurement-wrap"></div>' );
    } );
  }



  // End Wrapping Form Fields


  /**
   * Two-Column Layout
   * ─────────────────────────────────────────────────────────────────────────
   * Reusable pattern for placing two groups of GF fields side by side.
   * In GF admin, add:
   *   gf-two-col-left  — to the first field of the left group
   *   gf-two-col-right — to the first field of the right group
   * The function handles multiple instances automatically.
   */

  function initTwoColLayout( context ) {
    context = context || document;

    $( context ).find( '.gf-two-col-left' ).each( function() {
        var $leftStart  = $( this );

        if ( $leftStart.parent().hasClass( 'gf-two-col-left-group' ) ) return;

        var $rightStart = $leftStart.nextAll( '.gf-two-col-right' ).first();
        if ( ! $rightStart.length ) return;

        var $leftFields  = $leftStart.nextUntil( '.gf-two-col-right' ).addBack();
        var $rightFields = $rightStart.nextUntil( '.gf-two-col-left, .gf-two-col-end' ).addBack();

        var $container  = $( '<div class="gf-two-col-layout"></div>' );
        var $leftGroup  = $( '<div class="gf-two-col-left-group"></div>' );
        var $rightGroup = $( '<div class="gf-two-col-right-group"></div>' );

        $container.append( $leftGroup ).append( $rightGroup );
        $leftStart.before( $container );
        $leftGroup.append( $leftFields );
        $rightGroup.append( $rightFields );

        // Wrap inline field groups within each column
        [ $leftGroup, $rightGroup ].forEach( function( $group ) {
            $group.find( '.gf-inline-fields' ).each( function() {
                var $field = $( this );

                if ( $field.parent().hasClass( 'gf-inline-group' ) ) return;

                // Collect this field and contiguous siblings that also have the class
                var $inlineFields = $field;
                var $next = $field.next( '.gf-inline-fields' );

                while ( $next.length ) {
                    $inlineFields = $inlineFields.add( $next );
                    $next = $next.next( '.gf-inline-fields' );
                }

                $inlineFields.wrapAll( '<div class="gf-inline-group"></div>' );
            } );
        } );
    } );
  }

  // End Two-Column Layout


  /**
   * Unit Toggle
   *
   * Finds each .units-toggle-field, locates its closest .form-section ancestor and sets data-unit-system="imperial"|"metric" on it. CSS reads this attribute to swap the ::after unit labels on .imperial-weight and .imperial-dimension fields. Scoped per section so multiple toggle instances don't interfere.
   */

  function initUnitToggle( context ) {
      context = context || document;

      // Set initial attribute from current checked state (default: imperial)
      $( context ).find( '.units-toggle-field' ).each( function() {
          var $field   = $( this );
          var $section = $field.closest( '.form-section' );
          if ( ! $section.length ) return;

          // If no radio is checked, default to the first choice (Imperial)
          if ( ! $field.find( 'input[type="radio"]:checked' ).length ) {
              $field.find( 'input[type="radio"]' ).first().prop( 'checked', true );
          }

          var checked = $field.find( 'input[type="radio"]:checked' ).val();
          $section.attr( 'data-unit-system', checked === 'Metric' ? 'metric' : 'imperial' );
      } );

      // Update on change
      $( context ).find( '.units-toggle-field input[type="radio"]' )
          .off( 'change.units' )
          .on( 'change.units', function() {
              var $section = $( this ).closest( '.form-section' );
              if ( ! $section.length ) return;
              $section.attr( 'data-unit-system', $( this ).val() === 'Metric' ? 'metric' : 'imperial' );
              // Clones don't get GF's conditional logic, so the metric/imperial
              // measurement swap has to be reapplied by hand.
              $section.find( '.freight-item-block' ).each( function() {
                  syncClonedItemDgFields( $( this ) );
              } );
              serializeAllItems( context );
          } );
  }

  // End Unit Toggle


  /**
   * Sync Dangerous-Goods Fields In A CLONED Freight Item
   *
   * GF conditional logic never registers cloned block fields -- their IDs are
   * suffixed, so GF has no rule bound to them. For most of the freight block
   * that is handled by bespoke JS (see the packing-type and hazmat handlers in
   * bindFreightItemEvents). The dangerous-goods trio was missed:
   *
   *   .charter-payload-net-quantity        (field 214, net quantity per item)
   *   .imperial-weight-volume-measurement  (field 216)
   *   .metric-weight-volume-measurement    (field 217)
   *
   * all of which live inside .net-quantity-measurement-wrap. The result, seen
   * 2026-09-15: set Hazmat to Yes on a cloned item and the UN# field appears
   * (it has a handler) but net quantity and the measurement select do not --
   * they keep whatever inline display item 1 happened to have at clone time.
   *
   * Mirrors the ORIGINAL block's intent rather than its literal GF rules: field
   * 216's condition is recorded in the readme as gating on `65 is ''` instead of
   * `65 is 'Yes'`, which is a separate bug on the GF side. Reproducing that here
   * would spread it.
   *
   * CLONES ONLY. Item 1 is GF's to control and is deliberately left alone -- two
   * systems setting display on the same element is how this area got confusing
   * in the first place.
   *
   * Which of the two measurement selects shows follows the section's
   * data-unit-system, set by initUnitsToggle(). The hidden one is disabled as
   * well as hidden so it cannot post a stale value.
   */
  function syncClonedItemDgFields( $block ) {
      // Item 1 is GF's. Bail on anything that is not a clone.
      if ( ! $block.length || $block.attr( 'data-item' ) === '1' ) {
          return;
      }

      var $wrap = $block.find( '.net-quantity-measurement-wrap' );
      if ( ! $wrap.length ) {
          return;
      }

      /* Field 213 is a GF HTML block carrying the "If applicable, what is the net
       * quantity per item?" label. It sits OUTSIDE the wrapper (the JS wrapper
       * only groups 214/216/217), so hiding the wrap alone leaves the label
       * stranded above empty space. It has to move with the group. */
      var $label = $block.find( '.quantity-weight-volume-label-replacement' );

      var isHazmat = $block.find( '.hazmat-field input[type="radio"]:checked' ).val() === 'Yes';

      if ( ! isHazmat ) {
          $wrap.hide().find( 'input, select' ).prop( 'disabled', true );
          $label.hide();
          return;
      }

      var system     = $block.closest( '.form-section' ).attr( 'data-unit-system' ) || 'imperial';
      var $metric    = $wrap.find( '.metric-weight-volume-measurement' );
      var $imperial  = $wrap.find( '.imperial-weight-volume-measurement' );
      var $active    = system === 'metric' ? $metric : $imperial;
      var $inactive  = system === 'metric' ? $imperial : $metric;

      $wrap.show();
      $label.show();
      $wrap.find( '.charter-payload-net-quantity' ).show()
          .find( 'input' ).prop( 'disabled', false );

      $active.show().find( 'select' ).prop( 'disabled', false );
      $inactive.hide().find( 'select' ).prop( 'disabled', true );
  }


  /**
   * Freight Item Clone Mechanism
   * 
   * Clones the cargo item field block when the user adds items.
   * All item data is serialised to JSON and written to field 161
   * (class: cargo-items-json-field) for Zoho via the GF add-on.
   */

  function initFreightItemSystem( context ) {
      context = context || document;

      if ( ! $( context ).find( '.freight-item-section-marker' ).length ) return;

      wrapFreightItemBlock( context );
      injectFreightTotalsBar( context );
      initPackingTypeWeightLabels( context );

      var $firstBlock = $( context ).find( '.freight-item-block' ).first();
      if ( $firstBlock.length ) {
          bindLocalConditional( $firstBlock, context );
      }

      $( context ).find( '[data-action="add-freight-item"]' )
          .off( 'click.freight' )
          .on( 'click.freight', function() {
              addFreightItem( context );
          } );

      // Serialize before GF submits
      $( context ).closest( 'form' )
          .off( 'submit.freight' )
          .on( 'submit.freight', function() {
              serializeAllItems( context );
          } );

      serializeAllItems( context );
  }

  function injectFreightTotalsBar( context ) {
      if ( $( context ).find( '.freight-totals-bar' ).length ) return;

      var $bar = $(
          '<div class="freight-totals-bar">' +
              '<span class="freight-total freight-total--count">' +
                  '<strong>Total Item Count:</strong> ' +
                  '<span class="freight-total__value">0</span> Items' +
              '</span>' +
              '<span class="freight-total freight-total--weight">' +
                  '<strong>Total Weight:</strong> ' +
                  '<span class="freight-total__value">0</span>\u00a0<span class="freight-total__unit">lbs</span>' +
              '</span>' +
              '<span class="freight-total freight-total--volume">' +
                  '<strong>Total Volume:</strong> ' +
                  '<span class="freight-total__value">0</span> CBM ' +
                  '(approx.\u00a0<span class="freight-total__cft">0</span> CFT)' +
              '</span>' +
          '</div>'
      );

      $( context ).find( '.freight-item-controls' ).after( $bar );
  }

  function wrapFreightItemBlock( context ) {
    var $marker = $( context ).find( '.freight-item-section-marker' ).first();

    if ( ! $marker.length ) return;
    if ( $marker.closest( '.freight-item-block' ).length ) return;

    var $fields = $marker.nextUntil( '.freight-item-controls' ).addBack();
    $fields.wrapAll( '<div class="freight-item-block" data-item="1"></div>' );

    // Must run AFTER the block wrap above -- it scopes to .freight-item-block,
    // which does not exist until wrapAll() has run.
    initNetQuantityMeasurementWrap( context );

    // Wrap the block in a container for layout management
    $( context ).find( '.freight-item-block' ).first()
        .wrap( '<div class="freight-items-container"></div>' );
  }

  function addFreightItem( context ) {
      var $blocks  = $( context ).find( '.freight-item-block' );
      var itemNum  = $blocks.length + 1;
      var suffix   = '_item' + itemNum;
      var $clone   = $blocks.first().clone( false );

      // 1. Item number
      $clone.attr( 'data-item', itemNum );
      $clone.find( '.item-number' ).text( 'Item ' + itemNum ).show();

      // 2. Unique IDs
      $clone.find( '[id]' ).each( function() {
          $( this ).attr( 'id', $( this ).attr( 'id' ) + suffix );
      } );
      $clone.find( '[for]' ).each( function() {
          $( this ).attr( 'for', $( this ).attr( 'for' ) + suffix );
      } );
      $clone.find( '[aria-controls]' ).each( function() {
          $( this ).attr( 'aria-controls', $( this ).attr( 'aria-controls' ) + suffix );
      } );
      $clone.find( '[aria-describedby]' ).each( function() {
          $( this ).attr( 'aria-describedby', $( this ).attr( 'aria-describedby' ) + suffix );
      } );

      // 3. Suffix names so GF ignores them — data goes through JSON
      $clone.find( '[name]' ).each( function() {
          $( this ).attr( 'name', $( this ).attr( 'name' ) + suffix );
      } );

      // 4. Clear values and UI state
      $clone.find( 'input[type="text"], input[type="number"], textarea' ).val( '' );
      $clone.find( 'input[type="radio"]' ).prop( 'checked', false );
      $clone.find( '.is-focused' ).removeClass( 'is-focused' );
      $clone.find( '.charter-card__tip-btn' ).attr( 'aria-expanded', 'false' );
      $clone.find( '.charter-card__tip-bubble' ).attr( 'hidden', '' );
      $clone.find( '.gform-field-label[tabindex]' ).removeAttr( 'tabindex' );
      $clone.find( 'input[type="radio"][tabindex]' ).removeAttr( 'tabindex' );

      $clone.find( 'input[type="radio"], input[type="checkbox"]' ).each( function() {
        $( this ).removeAttr( 'onchange' );
      } );


      // Reset any inline styles applied by the selected card state
      $clone.find( '.gform-field-label' ).removeAttr( 'style' );

      // 5. Unwrap wrappers so they can be re-applied cleanly
      $clone.find( '.dimension-fields-wrap' ).each( function() {
          $( this ).replaceWith( $( this ).children() );
      } );
      $clone.find( '.number-stepper' ).each( function() {
          $( this ).replaceWith( $( this ).find( 'input[type="number"]' ) );
      } );

      // 6. Hide conditional fields for the fresh item
      $clone.find( '.specify-packing-field' ).hide().find( 'input, textarea' ).val( '' ).prop( 'disabled', true );
      $clone.find( '.un-number-field' ).hide().find( 'input, textarea' ).val( '' ).prop( 'disabled', true );
      // Dangerous-goods trio (214 / 216 / 217). Hidden and cleared to match the
      // un-chosen Hazmat state the clone starts in; syncClonedItemDgFields()
      // brings them back when Hazmat is set to Yes.
      $clone.find( '.net-quantity-measurement-wrap' ).hide()
          .find( 'input, select' ).val( '' ).prop( 'disabled', true );
      // Field 213's label block lives outside that wrapper, so it needs hiding
      // separately or it strands above the hidden group.
      $clone.find( '.quantity-weight-volume-label-replacement' ).hide();

      // 7. Remove button
      var $removeBtn = $(
          '<button type="button" class="freight-remove-item-btn" aria-label="Remove item ' + itemNum + '">' +
          '<span aria-hidden="true">×</span> Remove Item ' + itemNum +
          '</button>'
      );
      $clone.find( '.freight-item-section-marker' ).after( $removeBtn );

      // 8. Insert
      $( context ).find( '.freight-items-container' ).append( $clone );

      // 9. Re-init JS
      initCharterCards( $clone[ 0 ] );
      initNumberSteppers( $clone[ 0 ] );
      initDimensionFieldsWrap( $clone[ 0 ] );
      initPackingTypeWeightLabels( $clone[ 0 ] );
      bindLocalConditional( $clone, context );

      // 10. Remove handler
      $removeBtn.on( 'click', function() {
          $clone.remove();
          renumberFreightItems( context );
          serializeAllItems( context );
      } );

      serializeAllItems( context );

      scrollCloneIntoView( $clone[ 0 ] );
  }

  function bindLocalConditional( $block, context ) {
    var isClone = parseInt( $block.data( 'item' ) ) > 1;

    // Packing Type - Specify Packing Type
    $block.find( '.packing-type-field input[type="radio"]' )
        .off( 'change.freight' )
        .on( 'change.freight', function( e ) {
            if ( isClone ) e.stopPropagation();
            var $parentBlock = $( this ).closest( '.freight-item-block' );
            var $specifyField = $parentBlock.find( '.specify-packing-field' );
            if ( $( this ).val() === 'Other/Not Listed' ) {
                $specifyField.show().find( 'input, textarea' ).prop( 'disabled', false );
            } else {
                $specifyField.hide().find( 'input, textarea' ).prop( 'disabled', true ).val( '' );
            }
            updatePackingTypeLabel( $parentBlock );
            serializeAllItems( context );
        } );

    // Hazmat - UN#
    $block.find( '.hazmat-field input[type="radio"]' )
        .off( 'change.freight' )
        .on( 'change.freight', function( e ) {
            if ( isClone ) e.stopPropagation();
            var $parentBlock = $( this ).closest( '.freight-item-block' );
            var $unField = $parentBlock.find( '.un-number-field' );
            if ( $( this ).val() === 'Yes' ) {
                $unField.show().find( 'input, textarea' ).prop( 'disabled', false );
            } else {
                $unField.hide().find( 'input, textarea' ).prop( 'disabled', true ).val( '' );
            }
            // Net quantity + measurement select ride on the same Yes/No but have
            // no GF rule bound in a clone. No-op on item 1.
            syncClonedItemDgFields( $parentBlock );
            serializeAllItems( context );
        } );

    // ITAR and Stackable - no GF conditional logic to worry about
    $block.find( '.itar-field input[type="radio"], .stackable-field input[type="radio"]' )
        .off( 'change.freight' )
        .on( 'change.freight', function() {
            serializeAllItems( context );
        } );

    // Text and number inputs
    $block.find( 'input[type="text"], input[type="number"]' )
        .off( 'change.freight input.freight' )
        .on( 'change.freight input.freight', function() {
            if ( $( this ).closest( '.specify-packing-field' ).length ) {
                updatePackingTypeLabel( $( this ).closest( '.freight-item-block' ) );
            }
            serializeAllItems( context );
        } );
  }


  /**
   * Weight per [Packing Type] label token
   *
   * The GF label on field 59 is authored as "Weight per [Packing Type]".
   * On init the token is swapped for a <span class="packing-type-token">,
   * then rewritten per block whenever Packing Type (56) or Specify Packing
   * Type (57) changes. Falls back to "Item" when nothing is selected.
   */

  function initPackingTypeWeightLabels( context ) {
      context = context || document;

      $( context ).find( '.freight-item-block' ).each( function() {
          var $block = $( this );
          prepPackingTypeToken( $block );
          updatePackingTypeLabel( $block );
      } );
  }

  function prepPackingTypeToken( $block ) {
      var $label = $block.find( '.item-weight-field' )
          .find( '.gfield_label, .gform-field-label' ).first();

      if ( ! $label.length ) return;
      if ( $label.find( '.packing-type-token' ).length ) return;

      $label.contents().each( function() {
          if ( this.nodeType !== 3 ) return;
          if ( this.nodeValue.indexOf( '[Packing Type]' ) === -1 ) return;

          var parts = this.nodeValue.split( '[Packing Type]' );
          var frag  = document.createDocumentFragment();
          var span  = document.createElement( 'span' );

          span.className = 'packing-type-token';

          frag.appendChild( document.createTextNode( parts.shift() ) );
          frag.appendChild( span );
          frag.appendChild( document.createTextNode( parts.join( '[Packing Type]' ) ) );

          this.parentNode.replaceChild( frag, this );
      } );
  }

  function updatePackingTypeLabel( $block ) {
      var $token = $block.find( '.item-weight-field .packing-type-token' );
      if ( ! $token.length ) return;

      var packing = $block.find( '.packing-type-field input[type="radio"]:checked' ).val() || '';

      if ( packing === 'Other/Not Listed' ) {
          packing = $.trim(
              $block.find( '.specify-packing-field input, .specify-packing-field textarea' ).val() || ''
          );
      }

      $token.text( packing || 'Item' );
  }


  function renumberFreightItems( context ) {
      $( context ).find( '.freight-item-block' ).each( function( index ) {
          var itemNum = index + 1;
          $( this ).attr( 'data-item', itemNum );
          $( this ).find( '.item-number' ).text( 'Item ' + itemNum );
          $( this ).find( '.freight-remove-item-btn' )
              .attr( 'aria-label', 'Remove item ' + itemNum )
              .html( '<span aria-hidden="true">×</span> Remove Item ' + itemNum );
      } );
  }

  /* Parse a user-entered number safely.
   *
   * Bare parseFloat() silently corrupts two very common inputs:
   *   parseFloat( '$100.00' ) -> NaN  (GF's currency numberFormat prefixes '$')
   *   parseFloat( '1,200' )   -> 1    (stops at the thousands separator!)
   * Both then hit a `|| 0` fallback and land in the JSON as 0 or 1 with no
   * error anywhere -- a declared value of $100 became 0 in the Customs payload.
   *
   * Assumes DOT-decimal (GF numberFormat 'decimal_dot' on these fields), so
   * commas are treated as thousands separators and dropped. If a field is ever
   * switched to comma-decimal, this needs revisiting. */
  function parseNumericValue( raw ) {
      if ( raw === undefined || raw === null ) return 0;
      var s = String( raw ).trim();
      if ( '' === s ) return 0;
      s = s.replace( /[^0-9.,\-]/g, '' ); // drop currency symbols, spaces, units
      s = s.replace( /,/g, '' );          // thousands separators
      var n = parseFloat( s );
      return isFinite( n ) ? n : 0;
  }

  function serializeAllItems( context ) {
      var items       = [];
      var activeUnit  = getActiveUnit( context );
      var unitsToggle = getUnitsToggleValue( context );
      var totalCount  = 0;
      var totalWeight = 0;
      var totalCBM    = 0;

      $( context ).find( '.freight-item-block' ).each( function() {
          var $b     = $( this );
          var count  = parseNumericValue( $b.find( '.item-count-field input[type="number"]' ).val() );
          var weight = parseNumericValue( $b.find( '.item-weight-field input[type="number"]' ).val() );
          var l      = parseNumericValue( $b.find( '.item-dimension-field' ).eq( 0 ).find( 'input[type="number"]' ).val() );
          var w      = parseNumericValue( $b.find( '.item-dimension-field' ).eq( 1 ).find( 'input[type="number"]' ).val() );
          var h      = parseNumericValue( $b.find( '.item-dimension-field' ).eq( 2 ).find( 'input[type="number"]' ).val() );

          /* Dangerous-goods net quantity (214) and its unit (216 metric / 217
           * imperial), added 2026-09-11 at Novito's request ("they don't need
           * the ID; just send it in the JSON").
           *
           * PER-ITEM ON NAC, form-level on NAL -- 214/216/217 live INSIDE the
           * freight item block here (between UN# and ITAR), so they clone with
           * each item. NAL's equivalents (54/110/111) are single form-level
           * values mapped to flat Lead fields. Do not mirror one brand's
           * treatment onto the other.
           *
           * The unit select is chosen by the form-level Units toggle, NOT by a
           * :visible check. 216 and 217 are mutually exclusive on that toggle,
           * and visibility is unreliable inside a clone -- GF conditional logic
           * only knows original field IDs, so it never evaluates the suffixed
           * clones at all.
           *
           * Unit is sent VERBATIM ('weight in kilograms'), not normalised to
           * 'kg'. The phrase distinguishes weight from volume, which is the
           * whole point of a DG net quantity, and normalising would add a FOURTH
           * unit vocabulary to this payload (199 Imperial/Metric,
           * totals.weightUnit kg/lbs, and these phrases are already three).
           *
           * Empty string rather than 0 when unanswered -- a net quantity of
           * zero is a factual claim about a dangerous-goods declaration that we
           * cannot make. Mirrors un_number below and Declared_Value in PHP. */
          var netQtyRaw  = $b.find( '.charter-payload-net-quantity input[type="number"]' ).val();
          var netQty     = ( '' === netQtyRaw || undefined === netQtyRaw || null === netQtyRaw )
              ? ''
              : parseNumericValue( netQtyRaw );
          var netQtyUnit = ( '' === netQty )
              ? ''
              : ( $b.find( activeUnit === 'kg'
                  ? '.metric-weight-volume-measurement select'
                  : '.imperial-weight-volume-measurement select' ).val() || '' );
          /* Unit is gated on the quantity being present (2026-09-12). The 216/217
           * selects have NO blank first option, so an untouched item reports its
           * first choice ('weight in ounces') -- read unconditionally, every item
           * on every submission shipped a dangerous-goods unit with no quantity
           * to qualify, including items with is_hazmat: false. A unit alone is
           * noise at best and a false DG signal at worst. Quantity and unit are
           * one datum; send both or neither. */

          totalCount  += count;
          // Per-unit weight MUST be multiplied by item count -- the field is
          // "weight per unit" (see weight_per_unit below), same as the volume
          // calc on the next line. Omitting * count understated the totals bar
          // by a factor of the item count (fixed 2026-07-28).
          totalWeight += weight * count;

          // Volume per block: L × W × H × item count, then convert to CBM
          var rawVol = l * w * h * count;
          totalCBM += activeUnit === 'kg'
              ? rawVol / 1000000      // cm³ → CBM
              : rawVol / 61023.74;    // in³ → CBM

          // Keys match the Novito v2 target schema (Section 11.1): snake_case,
          // weight_per_unit, FLAT length/width/height (no nested dimensions),
          // commodity_description, and real booleans for hazmat/itar/stackable.
          // Units (Imperial/Metric) is a separate flat field, not per-item here.
          items.push( {
              packing_type:          $b.find( '.packing-type-field input[type="radio"]:checked' ).val() || '',
              specify_packing_type:  $b.find( '.specify-packing-field input[type="text"]' ).val() || '',
              item_count:            count,
              weight_per_unit:       weight,
              length:                l,
              width:                 w,
              height:                h,
              commodity_description: $b.find( '.commodity-description-field input[type="text"]' ).val() || '',
              is_hazmat:             $b.find( '.hazmat-field input[type="radio"]:checked' ).val() === 'Yes',
              un_number:             $b.find( '.un-number-field input[type="text"]' ).val() || '',
              /* CONFIRMED BY NOVITO (Constantino, 2026-09-14) -- these are the
               * two key names their parser reads for the "Net Quantity" and
               * "Weight/Volume Measurement" columns of their Cargo Items
               * subform. Asked rather than guessed; do not rename without a
               * matching change on their side.
               *
               * Supersedes the four-key alias hedge carried 09-12 to 09-14
               * (net_quantity_per_item / net_quantity_unit /
               * weight_volume_measurement, none ever built). net_quantity was
               * the only one of the four they read.
               *
               * NOTE the measurement key is weight_volume, NOT
               * weight_volume_measurement -- they truncate the label. This also
               * differs from NAL, where the same value lands in the Zoho field
               * Weight_Volume_Measurement (GitHub #334). The two brands do not
               * share this spelling; do not copy one to the other.
               *
               * TEMPORARY TWO-KEY HEDGE, added 2026-09-15 (GitHub #348).
               * weight_volume was confirmed by Constantino on 09-14 but arrives
               * BLANK in the Zoho subform column, while net_quantity lands fine.
               * Kylie relayed from the client that the field name should be
               * Weight_Volume_Measurement.
               *
               * Note lowercase weight_volume_measurement was ALREADY tried in the
               * 09-12 hedge and did not land either, so spelling alone does not
               * explain this. What is new is the CASING: every key we send is
               * lowercase snake_case, but Weight_Volume_Measurement is Zoho
               * API-name convention. If their parser matches case-sensitively,
               * the capitalised key is a different key from the one already
               * tried.
               *
               * So both go out for one round to see which populates the column.
               * COLLAPSE TO THE WINNER once observed -- carrying two keys for the
               * same datum is exactly the hedge removed on 09-14, and it is only
               * back because two readings of the client's message are still open:
               * they may be naming the JSON key, or they may be naming the Zoho
               * COLUMN (which is what NAL uses -- see the warning above). If the
               * capitalised key also arrives blank, the key is not the problem
               * and the open question is the one Novito has not answered: whether
               * that column is a picklist that rejects the eight phrase strings
               * ('weight in ounces', 'volume in fluid ounces', etc.).
               *
               * VALUE TEST RESULT, 2026-09-15: hardcoding a short code ('lbs')
               * under both keys ALSO arrived blank, while net_quantity: 33 landed
               * correctly in the adjacent column of the same subform row. So the
               * value format is not the cause and neither is the key spelling or
               * casing -- three variants have now been sent and none populate the
               * column. The parser reads the object (net_quantity proves it) but
               * does not write Weight/Volume Measurement from anything we send.
               *
               * Could not check the field type in Zoho: no Edit control on the
               * detail view, and Setup > Modules and Fields returns Permission
               * Denied on our account. Resolution is with Novito -- which key
               * their parser reads for that column, and whether the column is
               * mapped on their side at all (GitHub #348).
               *
               * Both values carry GF fields 214 (quantity) and 216/217 (the two
               * mutually-exclusive unit selects, resolved above by the Units
               * toggle). They are one datum -- see the gate above; unit is only
               * emitted when a quantity is present. */
              net_quantity:   netQty,
              weight_volume:  netQtyUnit,
              Weight_Volume_Measurement: netQtyUnit,
              is_itar:               $b.find( '.itar-field input[type="radio"]:checked' ).val() === 'Yes',
              is_stackable:          $b.find( '.stackable-field input[type="radio"]:checked' ).val() === 'Yes',

              /* Units toggle, repeated on every item. Added 2026-09-22 for
               * Novito's `Unit` subform column.
               *
               * Key is lowercase `units`, value is 'Imperial' / 'Metric'
               * verbatim -- both specified by the client via Kylie, GitHub #348,
               * 2026-09-22. Do NOT title-case the key to match
               * `Weight_Volume_Measurement`; lowercase was explicit.
               *
               * ⚠️ FORM-LEVEL value in a PER-ITEM object. Every row in a
               * multi-item submission carries the same string, and it duplicates
               * the flat `Units` field already on the lead (canonical 199; v2
               * §7.5 states Units applies to the whole cargo block and is not
               * per-item). The duplication is what they asked for -- they are
               * auditing the subform flow -- but a row's `units` says nothing
               * about that row. Do not read it back as per-item data, and do not
               * use it to infer anything about weight_volume, which IS per-item.
               *
               * Sourced from the same scoped read as totals.weightUnit, so the
               * two can never disagree about which toggle was read. They can
               * still differ in vocabulary: 'Imperial' here, 'lbs' there. */
              units:                 unitsToggle
          } );
      } );

      var totalCFT        = totalCBM * 35.3147;
      var weightUnitLabel = activeUnit === 'kg' ? 'kg' : 'lbs';
      // Weight can be decimal, so round the accumulation the same way volume
      // is rounded -- otherwise 0.1-style inputs surface float noise.
      var totalWeightOut  = Number( totalWeight.toFixed( 3 ) );

      // Update visual totals bar
      var $bar = $( context ).find( '.freight-totals-bar' );
      if ( $bar.length ) {
          $bar.find( '.freight-total--count .freight-total__value' ).text( totalCount );
          $bar.find( '.freight-total--weight .freight-total__value' ).text( totalWeightOut );
          $bar.find( '.freight-total--weight .freight-total__unit' ).text( weightUnitLabel );
          $bar.find( '.freight-total--volume .freight-total__value' ).text( Number( totalCBM.toFixed( 3 ) ) );
          $bar.find( '.freight-total__cft' ).text( Number( totalCFT.toFixed( 3 ) ) );
      }

      var payload = {
          items: items,
          totals: {
              itemCount:  totalCount,
              weight:     totalWeightOut,
              weightUnit: weightUnitLabel,
              volumeCBM:  Number( totalCBM.toFixed( 3 ) ),
              volumeCFT:  Number( totalCFT.toFixed( 3 ) )
          }
      };

      $( '.cargo-items-json-field' ).find( 'textarea, input' ).val( JSON.stringify( payload ) );
  }

  /**
   * Resolve the active unit system for Cargo item serialization.
   *
   * MUST be scoped. Two .units-toggle-field blocks exist in the DOM at the same
   * time (Cargo Transport + Customs Brokerage), and GF conditional logic hides
   * rather than removes, so an unscoped lookup returns whichever is first in DOM
   * order -- which can be the Customs selector while we are serializing Cargo
   * items. initUnitToggle() force-checks a default on every toggle it finds, so
   * both are always "checked" and the wrong one reads as valid.
   *
   * Scoping is per .form-section, the same pattern initUnitToggle() and
   * initCharterPayloadUnits() use. Falls back to the old unscoped lookup so a
   * markup change degrades to the previous behaviour instead of returning
   * undefined (which would silently resolve to 'lbs').
   *
   * Split into two functions 2026-09-22. getUnitsToggleValue() does the scoped
   * read and returns the toggle's own vocabulary ( 'Imperial' / 'Metric' );
   * getActiveUnit() converts that to kg/lbs for the totals bar. Everything above
   * about scoping applies to getUnitsToggleValue(), which is now the only place
   * the DOM is touched.
   *
   * The Cargo Items `units` key needs the raw toggle value, not kg/lbs -- that
   * is the vocabulary Zoho's flat `Units` picklist and Novito's subform column
   * both store.
   *
   * Returns '' only if no toggle is checked at all. In practice that does not
   * happen: initUnitToggle() force-checks a default, which is exactly why the
   * scoping above is load-bearing. It also means `units` ships the DEFAULT on a
   * submission where the user never touched the toggle -- unavoidable, and
   * consistent with canonical 199, which has always sent the same defaulted
   * value to the flat Units field.
   */
  function getUnitsToggleValue( context ) {
      context = context || document;

      var $scope = $( context ).find( '.freight-item-section-marker' ).first()
          .closest( '.form-section' );

      var val = $scope.length
          ? $scope.find( '.units-toggle-field input[type="radio"]:checked' ).val()
          : $( context ).find( '.units-toggle-field input[type="radio"]:checked' ).val();

      return val || '';
  }


  function getActiveUnit( context ) {
      return getUnitsToggleValue( context ) === 'Metric' ? 'kg' : 'lbs';
  }


  // End Freight Item Clone Mechanism



  /**
   * Multi-Stop Clone Mechanism
   */

  function initMultiStopSystem( context ) {
      context = context || document;

      if ( ! $( context ).find( '.multi-stop-section-marker' ).length ) return;

      wrapMultiStopBlock( context );

      $( document )
          .off( 'click.multistop-add' )
          .on( 'click.multistop-add', '[data-action="add-multi-stop"], .multi-stop-add-btn', function() {
              addMultiStop( context );
          } );

      // Re-serialize on any text change in the block
      $( context ).find( '.multi-stop-block input[type="text"]' )
          .off( 'change.multistop input.multistop' )
          .on( 'change.multistop input.multistop', function() {
              serializeMultiStops( context );
          } );

      // Serialize before GF submits
      $( context ).closest( 'form' )
          .off( 'submit.multistop' )
          .on( 'submit.multistop', function() {
              serializeMultiStops( context );
          } );

      serializeMultiStops( context );
  }

  function wrapMultiStopBlock( context ) {
    var $marker = $( context ).find( '.multi-stop-section-marker' ).first();

    if ( ! $marker.length ) return;
    if ( $marker.closest( '.multi-stop-block' ).length ) return;

    var $fields = $marker.nextUntil( '.multi-stop-controls' ).addBack();
    $fields.wrapAll( '<div class="multi-stop-block" data-stop="1"></div>' );

    $( context ).find( '.multi-stop-block' ).first()
        .wrap( '<div class="multi-stops-container"></div>' );
  }

  function addMultiStop( context ) {
      var $blocks  = $( context ).find( '.multi-stop-block' );
      var stopNum  = $blocks.length + 1;
      var suffix   = '_stop' + stopNum;
      var $clone   = $blocks.first().clone( false );

      // 1. Stop number
      $clone.attr( 'data-stop', stopNum );

      // 2. Unique IDs
      $clone.find( '[id]' ).each( function() {
          $( this ).attr( 'id', $( this ).attr( 'id' ) + suffix );
      } );
      $clone.find( '[for]' ).each( function() {
          $( this ).attr( 'for', $( this ).attr( 'for' ) + suffix );
      } );
      /* aria-controls MUST be suffixed too, not just for accessibility.
       * GF 3.1.1's datepicker resolves its target input from the toggle
       * button's aria-controls, so an unsuffixed value leaves every clone's
       * calendar button pointing at stop 1's input -- the calendar opens, but
       * on the wrong field, which reads as "the picker doesn't work" in a
       * clone. Added 2026-09-15; addFreightItem() already did this, multi-stop
       * and customs did not. */
      $clone.find( '[aria-controls]' ).each( function() {
          $( this ).attr( 'aria-controls', $( this ).attr( 'aria-controls' ) + suffix );
      } );
      $clone.find( '[aria-describedby]' ).each( function() {
          $( this ).attr( 'aria-describedby', $( this ).attr( 'aria-describedby' ) + suffix );
      } );

      // 3. Suffix names so GF ignores them — data goes through JSON
      $clone.find( '[name]' ).each( function() {
          $( this ).attr( 'name', $( this ).attr( 'name' ) + suffix );
      } );

      // 4. Clear values
      $clone.find( 'input[type="text"]' ).val( '' );

      // 5. Remove GF onchange from cloned inputs
      $clone.find( 'input' ).removeAttr( 'onchange' );

      /* 5b. Strip GF 3.1.1 datepicker state so the clone reads as uninitialised.
       *
       * GF marks an input data-initialized="true" once it has wired the
       * datepicker to it. .clone() copies that attribute, so GF sees an input it
       * believes it has already handled and skips binding the clone's toggle
       * button -- the calendar then never opens on that stop.
       *
       * This is why the bug looked intermittent: whether the clone works depends
       * on whether stop 1 had been initialised at the moment it was cloned. The
       * tell in the markup is the label id -- GF's own pattern is
       * input_1_91_stop2_label, whereas input_1_91_label_stop4 is our suffix
       * pasted onto stop 1's id, i.e. GF never touched that block.
       *
       * Also dropped: the keyboard-hint <kbd> and any open calendar dialog, both
       * of which carry stop 1's ids and are GF's to recreate.
       *
       * NOTE: deliberately no gformInitDatepicker() call here. That function
       * re-initialises EVERY datepicker on the page and causes calendar
       * conflicts across blocks -- see the readme. If GF turns out not to pick
       * these up on its own, the fix is a targeted init, not the global one. */
      $clone.find( '.gform-datepicker' ).removeAttr( 'data-initialized' );
      $clone.find( 'kbd[id^="keyboardHint_"]' ).remove();
      $clone.find( '.gform-datepicker-calendar' ).remove();
      $clone.find( '.gform-datepicker-toggle' ).attr( 'aria-expanded', 'false' );

      // 6. Remove button
      var $removeBtn = $(
          '<div class="multi-stop-remove-btn-wrap">' +
          '<button type="button" class="multi-stop-remove-btn" aria-label="Remove stop ' + stopNum + '">' +
          '<span aria-hidden="true">×</span> Remove Stop ' + stopNum +
          '</button>' +
          '</div>'
      );
      $clone.find( '.multi-stop-section-marker' ).after( $removeBtn );

      // 7. Insert
      $( context ).find( '.multi-stops-container' ).append( $clone );

      // 8. Bind text change on new clone
      $clone.find( 'input[type="text"]' )
          .on( 'change.multistop input.multistop', function() {
              serializeMultiStops( context );
          } );

      // 9. Remove handler
      $removeBtn.on( 'click', function() {
          $clone.remove();
          renumberMultiStops( context );
          serializeMultiStops( context );
      } );

      serializeMultiStops( context );
      scrollCloneIntoView( $clone[ 0 ] );
  }

  function renumberMultiStops( context ) {
      $( context ).find( '.multi-stop-block' ).each( function( index ) {
          var stopNum = index + 1;
          $( this ).attr( 'data-stop', stopNum );
          $( this ).find( '.multi-stop-remove-btn' )
              .attr( 'aria-label', 'Remove stop ' + stopNum )
              .html( '<span aria-hidden="true">×</span> Remove Stop ' + stopNum );
      } );
  }

  /**
   * Prune Orphaned Multi-Stop Clones
   *
   * GF conditional logic only knows about the ORIGINAL block's fields
   * (data-stop="1"). Cloned stops carry suffixed IDs and names, so GF never
   * hides them -- switching "Where to?" from Multi Stop to One Way / Round Trip
   * hid stop 1 but left stops 2..N sitting on the page (issue #223).
   *
   * updateSectionVisibility() already removes clones, but only when the WHOLE
   * section goes hidden. Flight Details stays visible under One Way / Round
   * Trip, so that path never fires. This runs the same removal at block level:
   * if every real field in stop 1 is hidden, the Multi Stop branch is inactive
   * and any clones are orphans.
   *
   * Removal (not hiding) matches the existing section-level behaviour -- a
   * hidden clone would come back populated the next time Multi Stop is chosen.
   */
  function pruneOrphanedMultiStops( context ) {
      context = context || document;

      var $clones = $( context ).find( '.multi-stop-block:not([data-stop="1"])' );
      if ( ! $clones.length ) return;

      var $first = $( context ).find( '.multi-stop-block[data-stop="1"]' ).first();
      if ( ! $first.length ) return;

      // find(), not children() -- other init functions may have wrapped the
      // fields in layout divs by the time this runs. HTML fields (the section
      // marker, the controls) are never toggled, so they can't be part of the test.
      var fields = $first.find( '.gfield:not(.gfield--type-html)' ).get();
      if ( ! fields.length ) return;

      var allHidden = fields.every( function( field ) {
          return field.style.display === 'none' || field.classList.contains( 'gfield_hidden' );
      } );

      if ( ! allHidden ) return;

      $clones.remove();
      renumberMultiStops( context );
      serializeMultiStops( context );
  }

  function serializeMultiStops( context ) {
    var stops = [];

    $( context ).find( '.multi-stop-block' ).each( function() {
        var $b = $( this );

        stops.push( {
            departure:   $b.find( '.multi-stop-dep input[type="text"]' ).val() || '',
            destination: $b.find( '.multi-stop-dest input[type="text"]' ).val() || '',
            date:        $b.find( '.multi-stop-date input[type="text"]' ).val() || ''
        } );
    } );

    $( '.multi-stop-json-field' ).find( 'textarea, input' ).val( JSON.stringify( stops ) );
  } 

  // End Multi-Stop Clone Mechanism


  /**
   * Customs Item Clone Mechanism
   *
   * Clones the customs item block when the user adds items.
   * All item data is serialised to JSON and written to field 163
   * (class: customs-items-json-field) for Zoho via the GF add-on.
   */

  function initCustomsItemSystem( context ) {
      context = context || document;

      if ( ! $( context ).find( '.customs-item-section-marker' ).length ) return;

      wrapCustomsItemBlock( context );

      $( context ).find( '[data-action="add-customs-item"]' )
          .off( 'click.customs' )
          .on( 'click.customs', function() {
              addCustomsItem( context );
          } );

      $( context ).find( '.customs-item-block input[type="text"], .customs-item-block input[type="number"], .customs-item-block select' )
          .off( 'change.customs input.customs' )
          .on( 'change.customs input.customs', function() {
              serializeCustomsItems( context );
          } );

      $( context ).closest( 'form' )
          .off( 'submit.customs' )
          .on( 'submit.customs', function() {
              serializeCustomsItems( context );
          } );

      serializeCustomsItems( context );
  }

  function wrapCustomsItemBlock( context ) {
      var $marker = $( context ).find( '.customs-item-section-marker' ).first();

      if ( ! $marker.length ) return;
      if ( $marker.closest( '.customs-item-block' ).length ) return;

      var $fields = $marker.nextUntil( '.customs-item-controls' ).addBack();
      $fields.wrapAll( '<div class="customs-item-block" data-item="1"></div>' );

      $( context ).find( '.customs-item-block' ).first()
          .wrap( '<div class="customs-items-container"></div>' );
  }

  function addCustomsItem( context ) {
      var $blocks  = $( context ).find( '.customs-item-block' );
      var itemNum  = $blocks.length + 1;
      var suffix   = '_customs' + itemNum;
      var $clone   = $blocks.first().clone( false );

      // 1. Item number
      $clone.attr( 'data-item', itemNum );
      $clone.find( '.customs-item-number' ).text( 'Item ' + itemNum ).show();

      // 2. Unique IDs
      $clone.find( '[id]' ).each( function() {
          $( this ).attr( 'id', $( this ).attr( 'id' ) + suffix );
      } );
      $clone.find( '[for]' ).each( function() {
          $( this ).attr( 'for', $( this ).attr( 'for' ) + suffix );
      } );
      /* See the note in addMultiStop(): aria-controls carries GF 3.1.1's
       * datepicker target, so leaving it unsuffixed points a clone's calendar
       * button at item 1's input. No date field on the customs block today,
       * but the omission is the same bug waiting to happen. */
      $clone.find( '[aria-controls]' ).each( function() {
          $( this ).attr( 'aria-controls', $( this ).attr( 'aria-controls' ) + suffix );
      } );
      $clone.find( '[aria-describedby]' ).each( function() {
          $( this ).attr( 'aria-describedby', $( this ).attr( 'aria-describedby' ) + suffix );
      } );

      // 3. Suffix names so GF ignores them — data goes through JSON
      $clone.find( '[name]' ).each( function() {
          $( this ).attr( 'name', $( this ).attr( 'name' ) + suffix );
      } );

      // 4. Clear values
      $clone.find( 'input[type="text"], input[type="number"]' ).val( '' );
      $clone.find( 'select' ).prop( 'selectedIndex', 0 );

      // 5. Remove GF onchange
      $clone.find( 'input, select' ).removeAttr( 'onchange' );

      // 5b. Unwrap the number stepper so it can be re-applied cleanly.
      // MUST happen before initNumberSteppers(): clone( false ) copies the
      // wrapper and buttons as markup but NOT their listeners, and the
      // double-init guard in initNumberSteppers() bails out on any input already
      // inside a .number-stepper -- so without this the cloned buttons render,
      // take the pointer cursor from CSS, and do nothing on click.
      // Mirrors step 5 of addFreightItem().
      $clone.find( '.number-stepper' ).each( function() {
          $( this ).replaceWith( $( this ).find( 'input[type="number"]' ) );
      } );

      // 6. Remove button
      var $removeBtn = $(
          '<div class="customs-remove-item-button-container"><button type="button" class="customs-remove-item-btn" aria-label="Remove item ' + itemNum + '">' +
          '<span aria-hidden="true">×</span> Remove Item ' + itemNum +
          '</button></div>'
      );
      $clone.find( '.customs-item-section-marker' ).after( $removeBtn );

      // 7. Insert
      $( context ).find( '.customs-items-container' ).append( $clone );

      // 7b. Re-init the stepper on the freshly inserted clone (see 5b).
      initNumberSteppers( $clone[ 0 ] );

      // 8. Bind change on clone
      $clone.find( 'input[type="text"], input[type="number"], select' )
          .on( 'change.customs input.customs', function() {
              serializeCustomsItems( context );
          } );

      // 9. Remove handler
      $removeBtn.on( 'click', function() {
          $clone.remove();
          renumberCustomsItems( context );
          serializeCustomsItems( context );
      } );

      serializeCustomsItems( context );
      scrollCloneIntoView( $clone[ 0 ] );
  }

  function renumberCustomsItems( context ) {
      $( context ).find( '.customs-item-block' ).each( function( index ) {
          var itemNum = index + 1;
          $( this ).attr( 'data-item', itemNum );
          $( this ).find( '.customs-item-number' ).text( 'Item ' + itemNum );
          $( this ).find( '.customs-remove-item-btn' )
              .attr( 'aria-label', 'Remove item ' + itemNum )
              .html( '<span aria-hidden="true">×</span> Remove Item ' + itemNum );
      } );
  }

  function serializeCustomsItems( context ) {
      var items = [];

      $( context ).find( '.customs-item-block' ).each( function() {
          var $b = $( this );
          // Keys match the Novito v2 target schema (Section 11.3). Note
          // country_of_manufacture (NOT country_of_origin) per the spec.
          //
          // Selectors are CLASS-based by deliberate choice. The first version of
          // this function matched three of these inputs on placeholder text
          // ( input[placeholder*="Electronic"], input[placeholder="0.00"],
          // input[placeholder*="8471"] ) and two of them silently stopped
          // matching when the placeholder copy was edited in the GF admin --
          // commodity_description and hs_code went out as empty strings on every
          // Customs Brokerage submission (found 2026-08-27, client QA). There is
          // no error to notice: .val() on an empty jQuery set is undefined, which
          // || '' turns into a valid-looking empty value.
          //
          // NEVER key a selector off placeholder, label or help text -- anyone
          // with form-editor access can change copy and break serialization
          // without touching code. The cloner in addCustomsItem() rewrites id,
          // for, aria-describedby and name but NOT class, so classes are the only
          // attribute that survives cloning unchanged. ( name is suffixed on
          // purpose in step 3, so name-based selectors would only ever match
          // item 1. )
          //
          // The three class-scoped lookups deliberately omit an input[type=...]
          // qualifier: each class wraps exactly one GF field, so the type adds
          // nothing, and hard-coding it would break the selector again if the
          // field were ever switched between Text and Number in the admin.
          items.push( {
              commodity_description:  $b.find( '.customs-commodity-description-field input' ).val() || '',
              item_count:             parseNumericValue( $b.find( '.customs-item-field input[type="number"]:first' ).val() ),
              value_of_goods:         parseNumericValue( $b.find( '.customs-value-of-goods-field input' ).val() ),
              hs_code:                $b.find( '.customs-hs-code-field input' ).val() || '',
              country_of_manufacture: $b.find( '.customs-item-field select' ).val() || ''
          } );
      } );

      $( '.customs-items-json-field' ).find( 'textarea, input' ).val( JSON.stringify( items ) );
  }

  // End Customs Item Clone Mechanism


  function initPlacesAutocomplete(context) {
    context = context || document;

    // Slotted into the light DOM — fill comes from _inputs.scss
    // (gmp-place-autocomplete > .gmp-icon svg path), so no fill attribute here.
    var ICON_SEARCH =
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M16.25 8.125C16.25 9.91797 15.668 11.5742 14.6875 12.918L19.6328 17.8672C20.1211 18.3555 20.1211 19.1484 19.6328 19.6367C19.1445 20.125 18.3516 20.125 17.8633 19.6367L12.918 14.6875C11.5742 15.668 9.91797 16.25 8.125 16.25C3.63672 16.25 0 12.6133 0 8.125C0 3.63672 3.63672 0 8.125 0C12.6133 0 16.25 3.63672 16.25 8.125ZM8.125 13.75C8.86369 13.75 9.59514 13.6045 10.2776 13.3218C10.9601 13.0391 11.5801 12.6248 12.1025 12.1025C12.6248 11.5801 13.0391 10.9601 13.3218 10.2776C13.6045 9.59514 13.75 8.86369 13.75 8.125C13.75 7.38631 13.6045 6.65486 13.3218 5.97241C13.0391 5.28995 12.6248 4.66985 12.1025 4.14752C11.5801 3.62519 10.9601 3.21086 10.2776 2.92818C9.59514 2.64549 8.86369 2.5 8.125 2.5C7.38631 2.5 6.65486 2.64549 5.97241 2.92818C5.28995 3.21086 4.66985 3.62519 4.14752 4.14752C3.62519 4.66985 3.21086 5.28995 2.92818 5.97241C2.64549 6.65486 2.5 7.38631 2.5 8.125C2.5 8.86369 2.64549 9.59514 2.92818 10.2776C3.21086 10.9601 3.62519 11.5801 4.14752 12.1025C4.66985 12.6248 5.28995 13.0391 5.97241 13.3218C6.65486 13.6045 7.38631 13.75 8.125 13.75Z"/>' +
        '</svg>';

    var ICON_CLEAR =
        '<svg width="20" height="20" viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0C10.287 0 6.72601 1.475 4.10051 4.10051C1.475 6.72601 0 10.287 0 14C0 17.713 1.475 21.274 4.10051 23.8995C6.72601 26.525 10.287 28 14 28ZM9.13281 9.13281C9.64688 8.61875 10.4781 8.61875 10.9867 9.13281L13.9945 12.1406L17.0023 9.13281C17.5164 8.61875 18.3477 8.61875 18.8562 9.13281C19.3648 9.64688 19.3703 10.4781 18.8562 10.9867L15.8484 13.9945L18.8562 17.0023C19.3703 17.5164 19.3703 18.3477 18.8562 18.8562C18.3422 19.3648 17.5109 19.3703 17.0023 18.8562L13.9945 15.8484L10.9867 18.8562C10.4727 19.3703 9.64141 19.3703 9.13281 18.8562C8.62422 18.3422 8.61875 17.5109 9.13281 17.0023L12.1406 13.9945L9.13281 10.9867C8.61875 10.4727 8.61875 9.64141 9.13281 9.13281Z"/>' +
        '</svg>';

    var PIN_FILL = '#005baa';   // literal value of $color-bkg--blue

    $(context).find('gmp-place-autocomplete').each(function () {
        var el = this;

        // GF doesn't pass its field placeholder through to the component.
        // Prefer the sibling GF input's placeholder so the GF admin
        // Appearance tab stays the source of truth; fall back to a default.
        if ( ! el.getAttribute( 'placeholder' ) ) {
            var gfInput = $( el ).closest( '.ginput_container' )
                                 .find( 'input[type="text"][placeholder]' )
                                 .first();
            var ph = gfInput.length ? ( gfInput.attr( 'placeholder' ) || '' ) : '';
            el.setAttribute( 'placeholder', ph || 'Search for a location' );
        }

        if (!el.querySelector('[slot="input-icon"]')) {
            $(el).append('<span slot="input-icon" class="gmp-icon gmp-icon--search">' + ICON_SEARCH + '</span>');
        }

        if (!el.querySelector('[slot="clear-icon"]')) {
            $(el).append('<span slot="clear-icon" class="gmp-icon gmp-icon--clear">' + ICON_CLEAR + '</span>');
        }

        // Documented slot — takes exactly one <template>, cloned into the
        // shadow tree per prediction, so the fill must be inline.
        if (!el.querySelector('template[slot="prediction-item-icon"]')) {
            var tpl = document.createElement('template');
            tpl.setAttribute('slot', 'prediction-item-icon');
            tpl.innerHTML =
                '<svg viewBox="0 0 27 26" width="20" height="20" fill="none" aria-hidden="true" focusable="false">' +
                '<path fill-rule="evenodd" clip-rule="evenodd" fill="' + PIN_FILL + '" d="M13.0651 1.69019C8.60658 1.69019 4.98663 5.31013 4.98663 9.76862C4.98663 11.1476 5.60544 13.0339 6.52154 15.0325C7.81893 17.8665 9.69555 20.9556 10.9744 23.0892C11.4025 23.8429 12.2031 24.3098 13.0707 24.3098C13.4974 24.3099 13.9164 24.1966 14.2848 23.9815C14.6533 23.7665 14.9581 23.4574 15.1679 23.0859C16.4467 20.9556 18.3185 17.8665 19.6135 15.0317C20.5271 13.0331 21.1435 11.1476 21.1435 9.76862C21.1435 5.31013 17.5244 1.69019 13.0651 1.69019ZM13.0651 3.30587C16.6325 3.30587 19.5278 6.20199 19.5278 9.76862C19.5278 10.9747 18.9438 12.6114 18.144 14.3604C16.8724 17.1426 15.0306 20.1745 13.776 22.266L13.7639 22.2878C13.6948 22.4109 13.5942 22.5135 13.4724 22.5849C13.3506 22.6563 13.2119 22.694 13.0707 22.6941C12.9295 22.6942 12.7908 22.6566 12.669 22.5851C12.5471 22.5137 12.4465 22.411 12.3776 22.2878C12.3736 22.2805 12.3695 22.2732 12.3655 22.2668C11.1109 20.1745 9.26497 17.1426 7.9902 14.3596C7.18882 12.6114 6.60232 10.9747 6.60232 9.76862C6.60232 6.20199 9.49844 3.30587 13.0651 3.30587ZM13.0707 6.53725C11.287 6.53725 9.83935 7.9849 9.83935 9.76862C9.83935 11.5523 11.287 13 13.0707 13C14.8544 13 16.3021 11.5523 16.3021 9.76862C16.3021 7.9849 14.8544 6.53725 13.0707 6.53725ZM13.0707 8.15294C13.9626 8.15294 14.6864 8.87676 14.6864 9.76862C14.6864 10.6605 13.9626 11.3843 13.0707 11.3843C12.1789 11.3843 11.455 10.6605 11.455 9.76862C11.455 8.87676 12.1789 8.15294 13.0707 8.15294Z"/>' +
                '</svg>';
            el.appendChild(tpl);
        }
    });

    initPlacesValueGuard( context );
    restorePlacesDisplayValue( context );
    applyPlaceTypeRestrictions( context );

    // Also re-asserted here, not just on the country select's change event. The
    // component is created asynchronously once the Maps JS API loads, so a
    // country chosen before that finishes fires change against an element that
    // does not exist yet and the restriction is silently lost for the session.
    // Same gap after a GF validation re-render, where the select keeps its value
    // but fires no change. This runs on the MutationObserver pass that sees the
    // component appear, and on gform_post_render.
    applyRegionRestrictions( context );
}


  /* Location autocomplete -- "undefined" replaces the address on refocus
   * ===
   * Gravity Forms Geolocation 1.5.2, usePlaceAutocompleteElement path
   * ( gravityformsgeolocation/assets/js/dist/scripts-theme.min.js, fn K ),
   * inserts <gmp-place-autocomplete> as a SIBLING of the real street input
   * ( input_<form>_<field>_1 ) and toggles display between the two: the
   * component is shown while searching, the real input once a prediction is
   * chosen. Its gmp-select handler ends with
   *
   *     l.value = r.displayName;
   *
   * where r is a PlacePrediction. PlacePrediction exposes text / mainText /
   * secondaryText / placeId -- displayName belongs to Place, NOT to the
   * prediction -- so the assignment is undefined, the component coerces it to
   * the literal string "undefined", and the add-on's own focus handler then
   * swaps that box back into view in place of the filled street input.
   *
   * Reported in client QA 2026-08-03 (GH national-air-cargo #165): "I clicked on
   * the Origin Street Address field, which seemed to delete the street address
   * and replace it with 'undefined'".
   *
   * The DATA is never affected. The real street input keeps its value the whole
   * time and is only display:none, which is why those submissions still
   * validated and still carried a correct address downstream. Display only --
   * do not go looking for bad Zoho records from this.
   *
   * Fix: record the prediction's own label on gmp-select, then re-assert it onto
   * the component when the street input is focused. Focus is the exact moment
   * the add-on reveals the component, and our listener is registered after
   * theirs on the same element, so it runs later in the same dispatch and wins.
   * Patching the add-on is not an option ( plugin file, lost on update ) and
   * there is no filter around that assignment -- the two available filters
   * ( gform_geolocation_place_autocomplete_element_options and
   * ..._place_details ) both run before it.
   */

  function initPlacesValueGuard( context ) {
      context = context || document;

      $( context ).find( 'gmp-place-autocomplete' ).each( function() {
          var ac = this;

          if ( ac.getAttribute( 'data-lk-value-guard' ) ) { return; }

          var street = $( ac ).closest( '.ginput_container_address' )
                              .find( '.address_line_1 input' )[ 0 ];

          // Same selector the add-on uses to find its own target, so if this
          // misses, the add-on never wired this component up either.
          if ( ! street ) { return; }

          ac.setAttribute( 'data-lk-value-guard', '1' );

          ac.addEventListener( 'gmp-select', function( ev ) {
              var p     = ev && ev.placePrediction;
              var label = '';

              // PlacePrediction.text is a FormattableText ( { text, matches } ),
              // not a string. mainText is the fallback if a component build
              // omits text.
              if ( p ) {
                  if ( p.text && p.text.text ) {
                      label = p.text.text;
                  } else if ( p.mainText && p.mainText.text ) {
                      label = p.mainText.text;
                  }
              }

              ac.setAttribute( 'data-lk-label', label );
          } );

          street.addEventListener( 'focus', function() {
              var current = ac.value;
              var label   = ac.getAttribute( 'data-lk-label' ) || street.value || '';

              // Only correct a value the add-on has broken. Never clobber text
              // the user is part-way through typing.
              if ( current !== 'undefined' && current !== '' &&
                   current !== undefined && current !== null ) {
                  return;
              }

              try {
                  ac.value = label;
              } catch ( e ) {
                  // value setter unsupported on this component build; the field
                  // stays as the add-on left it.
              }
          } );
      } );
  }


  /* Address looks emptied after a GF validation re-render
   * ===
   * Reported post-launch 2026-09-17. Submit the NAC quote form with a required
   * field blank and the Origin / Destination street lines come back empty, while
   * City and ZIP repopulate normally.
   *
   * DISPLAY ONLY -- the data survives. Confirmed on the live site: both real
   * street inputs held their values ( 'Niittyportti 4', 'Rue 1.203' ) at
   * display:none while the empty <gmp-place-autocomplete> sat visible beside
   * them. Same sibling-and-toggle arrangement behind GH #165. A user who ignores
   * the empty box and resubmits still carries the original address. Do not go
   * looking for truncated Zoho records from this.
   *
   * Why City and ZIP are unaffected: they are plain inputs, so GF's repopulation
   * is visible. The street line is the one the add-on covers with its component.
   *
   * Fix: mirror the street input's value onto the component so the visible box
   * shows what will actually be submitted.
   *
   * MUST be setAttribute, not `ac.value =`. The property assignment is swallowed
   * on this component build -- no throw, no effect, verified on the live site
   * ( acValue stayed '' immediately after assigning ). The attribute path works.
   * Same property-vs-attribute split already documented for
   * `included-primary-types` in applyPlaceTypeRestrictions().
   *
   * ⚠️ The `ac.value = label` line in initPlacesValueGuard() above is the same
   * assignment and is therefore probably inert too. NOT changed here: the #165
   * focus path was not re-tested in this pass, and this fix is deliberately
   * additive. Verify the 'undefined'-on-refocus symptom is still fixed before
   * touching it.
   *
   * Rejected alternative: swapping display back ( show the real input, hide the
   * component ) also shows the address, but the add-on's focus handler does not
   * re-bind after a re-render, so the component never returns and the field
   * loses autocomplete for the rest of the page load. That silently defeats the
   * street-level and region restrictions this file works to enforce. Tested on
   * the live site 2026-09-17 -- focusing either field left it a plain text box.
   */

  function restorePlacesDisplayValue( context ) {
      context = context || document;

      $( context ).find( '.ginput_container_address' ).each( function() {
          var ac     = $( this ).find( 'gmp-place-autocomplete' )[ 0 ];
          var street = $( this ).find( '.address_line_1 input' )[ 0 ];

          if ( ! ac || ! street ) { return; }

          // Only ever fill an empty component from a filled input. Never the
          // reverse, and never over a value the component already shows -- the
          // add-on owns it from that point on.
          if ( ! street.value || ac.getAttribute( 'value' ) ) { return; }

          ac.setAttribute( 'value', street.value );

          // Give the #165 focus guard something to fall back on. It reads
          // data-lk-label, which is only set by gmp-select -- unset after a
          // re-render, since no selection has happened on this page load.
          if ( ! ac.getAttribute( 'data-lk-label' ) ) {
              ac.setAttribute( 'data-lk-label', street.value );
          }
      } );
  }


  /* Restrict suggestions to street-level addresses
   * ===
   * Typing "New" surfaced whole states and towns -- "New Jersey, USA",
   * "New Kensington, PA, USA" -- and picking one produced a place with no street
   * number or route, so the add-on's mapper wrote an empty street line. Client QA
   * 2026-08-03 / 09-01: "form allows me to just search a state, but then returns
   * undefined". Requesters are not shipping from a whole state, so these
   * predictions are noise at best.
   *
   * The add-on constructs the component with `types: ['address']`, a Beta option
   * on PlaceAutocompleteElementOptions. It does not exclude administrative or
   * locality results: a prediction for New Kensington came back with types
   * ["political","geocode","locality"] while that option was live.
   *
   * includedPrimaryTypes is the hard filter -- a place is returned only if its
   * PRIMARY type is in the list, max 5 values. Two things about applying it on
   * this build ( Maps v=beta, Sep 2026 ):
   *
   *   1. Property assignment does NOT register. Setting ac.includedPrimaryTypes
   *      throws nothing and reads back null, and no attribute appears. The
   *      reflected HTML attribute has to be set instead. Note this differs from
   *      includedRegionCodes on the very same element, where property assignment
   *      does reflect ( see applyRegionRestrictions below ) -- do not assume the
   *      two behave alike.
   *   2. The add-on's `types` is cleared at the same time. Both were changed
   *      together in the test that fixed this, so which one mattered is not
   *      established; clearing a now-redundant looser filter is harmless, so
   *      both are done here rather than guessing.
   *
   * Type choice: street_address and premise cover most numbered addresses,
   * subpremise covers suites and units, route covers street-level hits without a
   * number. Verified against US addresses only. If international predictions come
   * back thin, this list is the first thing to widen -- Google classifies a lot of
   * non-US addresses differently, and there are 5 slots with 4 in use.
   *
   * Not routed through the gform_geolocation_place_autocomplete_element_options
   * filter because that fires during the add-on's own gform/postRender handler,
   * so our filter would have to be registered before it -- a race. Setting the
   * attribute after the fact is deterministic. */

  var PLACE_PRIMARY_TYPES = 'street_address premise subpremise route';

  function applyPlaceTypeRestrictions( context ) {
      context = context || document;

      $( context ).find( 'gmp-place-autocomplete' ).each( function() {
          var ac = this;

          if ( ac.getAttribute( 'included-primary-types' ) === PLACE_PRIMARY_TYPES ) {
              return;
          }

          // Drop the add-on's looser constructor-time filter first.
          try {
              ac.types = undefined;
          } catch ( e ) {
              // Beta-only property, absent on some builds. The attribute below
              // is the one that does the work.
          }

          ac.setAttribute( 'included-primary-types', PLACE_PRIMARY_TYPES );
      } );
  }


  /* Restrict Places autocomplete to the selected country
   * ===
   * The country dropdown and the location autocomplete were separate, unlinked
   * controls: picking "United States" as Origin Country then typing "nova" still
   * suggested Nova Scotia, Canada. This links them.
   *
   * <gmp-place-autocomplete> takes `includedRegionCodes` -- an array of lowercase
   * ISO 3166-1 alpha-2 codes. The GF dropdowns store full country NAMES
   * ('United States') deliberately: Novito is aligning the Zoho picklists to our
   * strings verbatim, so the submitted values must stay as names. Hence the
   * name -> code lookup below.
   *
   * The map was generated from the form's own 249 dropdown values matched against
   * the pycountry ISO database, not typed by hand. Five needed manual resolution
   * because GF's wording differs from ISO's. Note 'Congo' -> cg and 'Congo,
   * Democratic Republic of the' -> cd are correctly DISTINCT countries -- do not
   * "tidy" them together.
   *
   * An unrecognised name applies NO restriction, so the field degrades to
   * worldwide search rather than matching nothing. */

  var COUNTRY_NAME_TO_REGION = {
    'Afghanistan':'af', 'Albania':'al', 'Algeria':'dz',
    'American Samoa':'as', 'Andorra':'ad', 'Angola':'ao',
    'Anguilla':'ai', 'Antarctica':'aq', 'Antigua and Barbuda':'ag',
    'Argentina':'ar', 'Armenia':'am', 'Aruba':'aw',
    'Australia':'au', 'Austria':'at', 'Azerbaijan':'az',
    'Bahamas':'bs', 'Bahrain':'bh', 'Bangladesh':'bd',
    'Barbados':'bb', 'Belarus':'by', 'Belgium':'be',
    'Belize':'bz', 'Benin':'bj', 'Bermuda':'bm',
    'Bhutan':'bt', 'Bolivia':'bo', 'Bonaire, Sint Eustatius and Saba':'bq',
    'Bosnia and Herzegovina':'ba', 'Botswana':'bw', 'Bouvet Island':'bv',
    'Brazil':'br', 'British Indian Ocean Territory':'io', 'Brunei Darussalam':'bn',
    'Bulgaria':'bg', 'Burkina Faso':'bf', 'Burundi':'bi',
    'Cabo Verde':'cv', 'Cambodia':'kh', 'Cameroon':'cm',
    'Canada':'ca', 'Cayman Islands':'ky', 'Central African Republic':'cf',
    'Chad':'td', 'Chile':'cl', 'China':'cn',
    'Christmas Island':'cx', 'Cocos Islands':'cc', 'Colombia':'co',
    'Comoros':'km', 'Congo':'cg', 'Congo, Democratic Republic of the':'cd',
    'Cook Islands':'ck', 'Costa Rica':'cr', 'Croatia':'hr',
    'Cuba':'cu', 'Curaçao':'cw', 'Cyprus':'cy',
    'Czechia':'cz', 'Côte d\'Ivoire':'ci', 'Denmark':'dk',
    'Djibouti':'dj', 'Dominica':'dm', 'Dominican Republic':'do',
    'Ecuador':'ec', 'Egypt':'eg', 'El Salvador':'sv',
    'Equatorial Guinea':'gq', 'Eritrea':'er', 'Estonia':'ee',
    'Eswatini':'sz', 'Ethiopia':'et', 'Falkland Islands':'fk',
    'Faroe Islands':'fo', 'Fiji':'fj', 'Finland':'fi',
    'France':'fr', 'French Guiana':'gf', 'French Polynesia':'pf',
    'French Southern Territories':'tf', 'Gabon':'ga', 'Gambia':'gm',
    'Georgia':'ge', 'Germany':'de', 'Ghana':'gh',
    'Gibraltar':'gi', 'Greece':'gr', 'Greenland':'gl',
    'Grenada':'gd', 'Guadeloupe':'gp', 'Guam':'gu',
    'Guatemala':'gt', 'Guernsey':'gg', 'Guinea':'gn',
    'Guinea-Bissau':'gw', 'Guyana':'gy', 'Haiti':'ht',
    'Heard Island and McDonald Islands':'hm', 'Holy See':'va', 'Honduras':'hn',
    'Hong Kong':'hk', 'Hungary':'hu', 'Iceland':'is',
    'India':'in', 'Indonesia':'id', 'Iran':'ir',
    'Iraq':'iq', 'Ireland':'ie', 'Isle of Man':'im',
    'Israel':'il', 'Italy':'it', 'Jamaica':'jm',
    'Japan':'jp', 'Jersey':'je', 'Jordan':'jo',
    'Kazakhstan':'kz', 'Kenya':'ke', 'Kiribati':'ki',
    'Korea, Democratic People\'s Republic of':'kp', 'Korea, Republic of':'kr', 'Kuwait':'kw',
    'Kyrgyzstan':'kg', 'Lao People\'s Democratic Republic':'la', 'Latvia':'lv',
    'Lebanon':'lb', 'Lesotho':'ls', 'Liberia':'lr',
    'Libya':'ly', 'Liechtenstein':'li', 'Lithuania':'lt',
    'Luxembourg':'lu', 'Macao':'mo', 'Madagascar':'mg',
    'Malawi':'mw', 'Malaysia':'my', 'Maldives':'mv',
    'Mali':'ml', 'Malta':'mt', 'Marshall Islands':'mh',
    'Martinique':'mq', 'Mauritania':'mr', 'Mauritius':'mu',
    'Mayotte':'yt', 'Mexico':'mx', 'Micronesia':'fm',
    'Moldova':'md', 'Monaco':'mc', 'Mongolia':'mn',
    'Montenegro':'me', 'Montserrat':'ms', 'Morocco':'ma',
    'Mozambique':'mz', 'Myanmar':'mm', 'Namibia':'na',
    'Nauru':'nr', 'Nepal':'np', 'Netherlands':'nl',
    'New Caledonia':'nc', 'New Zealand':'nz', 'Nicaragua':'ni',
    'Niger':'ne', 'Nigeria':'ng', 'Niue':'nu',
    'Norfolk Island':'nf', 'North Macedonia':'mk', 'Northern Mariana Islands':'mp',
    'Norway':'no', 'Oman':'om', 'Pakistan':'pk',
    'Palau':'pw', 'Palestine, State of':'ps', 'Panama':'pa',
    'Papua New Guinea':'pg', 'Paraguay':'py', 'Peru':'pe',
    'Philippines':'ph', 'Pitcairn':'pn', 'Poland':'pl',
    'Portugal':'pt', 'Puerto Rico':'pr', 'Qatar':'qa',
    'Romania':'ro', 'Russian Federation':'ru', 'Rwanda':'rw',
    'Réunion':'re', 'Saint Barthélemy':'bl', 'Saint Helena, Ascension and Tristan da Cunha':'sh',
    'Saint Kitts and Nevis':'kn', 'Saint Lucia':'lc', 'Saint Martin':'mf',
    'Saint Pierre and Miquelon':'pm', 'Saint Vincent and the Grenadines':'vc', 'Samoa':'ws',
    'San Marino':'sm', 'Sao Tome and Principe':'st', 'Saudi Arabia':'sa',
    'Senegal':'sn', 'Serbia':'rs', 'Seychelles':'sc',
    'Sierra Leone':'sl', 'Singapore':'sg', 'Sint Maarten':'sx',
    'Slovakia':'sk', 'Slovenia':'si', 'Solomon Islands':'sb',
    'Somalia':'so', 'South Africa':'za', 'South Georgia and the South Sandwich Islands':'gs',
    'South Sudan':'ss', 'Spain':'es', 'Sri Lanka':'lk',
    'Sudan':'sd', 'Suriname':'sr', 'Svalbard and Jan Mayen':'sj',
    'Sweden':'se', 'Switzerland':'ch', 'Syria Arab Republic':'sy',
    'Taiwan':'tw', 'Tajikistan':'tj', 'Tanzania, the United Republic of':'tz',
    'Thailand':'th', 'Timor-Leste':'tl', 'Togo':'tg',
    'Tokelau':'tk', 'Tonga':'to', 'Trinidad and Tobago':'tt',
    'Tunisia':'tn', 'Turkmenistan':'tm', 'Turks and Caicos Islands':'tc',
    'Tuvalu':'tv', 'Türkiye':'tr', 'US Minor Outlying Islands':'um',
    'Uganda':'ug', 'Ukraine':'ua', 'United Arab Emirates':'ae',
    'United Kingdom':'gb', 'United States':'us', 'Uruguay':'uy',
    'Uzbekistan':'uz', 'Vanuatu':'vu', 'Venezuela':'ve',
    'Viet Nam':'vn', 'Virgin Islands, British':'vg', 'Virgin Islands, U.S.':'vi',
    'Wallis and Futuna':'wf', 'Western Sahara':'eh', 'Yemen':'ye',
    'Zambia':'zm', 'Zimbabwe':'zw', 'Åland Islands':'ax'
  };

  /* Which country <select> governs which autocomplete. Paired by CSS CLASS, not
   * field ID, because field IDs differ between local and staging. Add these in
   * GF admin -> Appearance -> Custom CSS Class. */
  var LOCATION_REGION_PAIRS = [
    { country: '.origin-country-field',      location: '.origin-location-field' },
    { country: '.destination-country-field', location: '.destination-location-field' }
  ];

  function applyRegionRestrictions( context ) {
      context = context || document;

      LOCATION_REGION_PAIRS.forEach( function( pair ) {
          var select = $( context ).find( pair.country ).find( 'select' )[ 0 ];
          var ac     = $( context ).find( pair.location ).find( 'gmp-place-autocomplete' )[ 0 ];

          // The autocomplete is created asynchronously once the Maps JS API
          // loads, so it legitimately may not exist yet on an early pass.
          if ( ! select || ! ac ) return;

          var code = COUNTRY_NAME_TO_REGION[ select.value ];

          try {
              ac.includedRegionCodes = code ? [ code ] : null;
          } catch ( e ) {
              // Component build may not support the property; suggestions stay
              // unrestricted, which is the pre-existing behaviour.
          }
      } );
  }

  // Delegated so it survives GF conditional logic and AJAX re-renders.
  $( document ).on(
      'change.regionRestrict',
      '.origin-country-field select, .destination-country-field select',
      function() {
          applyRegionRestrictions( document );
      }
  );


  // GF's Places integration creates <gmp-place-autocomplete> after the Maps JS
  // API finishes loading async, which is after DOMContentLoaded and after
  // gform_post_render. Watch for it instead of assuming it's already there.

  function watchPlacesAutocomplete() {
    initPlacesAutocomplete( document );

    var observer = new MutationObserver( function( mutations ) {
      for ( var i = 0; i < mutations.length; i++ ) {
        var added = mutations[ i ].addedNodes;

        for ( var j = 0; j < added.length; j++ ) {
          var node = added[ j ];

          if ( node.nodeType !== 1 ) { continue; }

          if ( node.tagName === 'GMP-PLACE-AUTOCOMPLETE' ||
               node.querySelector( 'gmp-place-autocomplete' ) ) {
            initPlacesAutocomplete( document );
            return;
          }
        }
      }
    } );

    observer.observe( document.body, { childList: true, subtree: true } );
  }




  /**
   * Form Page — Validation Scroll Control
   *
   * .form-container is pulled up with position:relative / top:-19rem, so its
   * layout box sits ~19rem below where it visually renders. GF scrolls to that
   * computed offset after an error response, which lands mid-hero and pushes
   * .form-page-hero-content off screen. Reset scroll so the error state matches
   * a fresh page load.
   */

  function formPageErrorScrollTop() {
      var hero = document.querySelector( '.form-page' );
      if ( ! hero ) { return null; }

      if ( ! document.querySelector( '.gform_validation_errors, .gform_submission_error' ) ) {
          return null;
      }

      var header = document.querySelector( '.site-header' );
      var offset = header ? header.getBoundingClientRect().height : 0;

      return Math.max( hero.getBoundingClientRect().top + window.pageYOffset - offset, 0 );
  }

  function formPageResetScroll() {
      var top = formPageErrorScrollTop();
      if ( top === null ) { return; }

      // GF's own scroll fires after gform_post_render, so run after it.
      window.requestAnimationFrame( function() {
          window.scrollTo( 0, top );
      } );

      setTimeout( function() {
          window.scrollTo( 0, top );
      }, 80 );
  }

  // Non-AJAX submits come back with a #gf_N anchor in the URL, which the
  // browser jumps to on load. Drop it and reset for the same reason.

  function formPageStripAnchor() {
      if ( ! /^#gf_/.test( window.location.hash ) ) { return; }

      var top = formPageErrorScrollTop();
      if ( top === null ) { return; }

      if ( window.history.replaceState ) {
          window.history.replaceState( null, '', window.location.pathname + window.location.search );
      }

      formPageResetScroll();
  }


  /* Attribution capture lives in assets/js/attribution.js, NOT here.
   * It writes the `nac_attr` cookie (first + last touch, 90-day TTL); the PHP
   * side reads it in inc/plugin-settings/gravity-forms-settings.php via
   * gform_field_value_{param}. A duplicate implementation briefly existed in
   * this file writing a `nat_attr` cookie -- removed 2026-08-14. Do not re-add
   * capture here: two writers on near-identical cookie names is how this went
   * wrong the first time. */


  /* Input character restrictions -- class-driven
   * ===
   * Add ONE of these to the GF field's Appearance -> Custom CSS Class:
   *
   *   input-digits-only       digits only
   *   input-decimal-only      digits plus a single decimal point
   *   input-number-formatted  digits, commas, decimal points, spaces, hyphens
   *   input-letters-only      letters, spaces, hyphens, apostrophes, periods
   *
   * SUB-INPUT SCOPED (for composite Address fields, where the CSS class sits on
   * the whole .gfield and a field-level filter would also hit street and city):
   *
   *   input-postal-code    ZIP sub-input only: alphanumerics, spaces, hyphens
   *   input-postal-digits  ZIP sub-input only: digits and hyphens (US-ONLY)
   *
   * No PHP or per-field JS needed -- adding the class is the whole setup.
   *
   * WHY `input` AND NOT `keydown`: blocking keystrokes breaks paste, browser
   * autofill, and mobile IME/predictive input, and is hostile to assistive tech.
   * Sanitising the value after the fact handles paste and autofill for free.
   *
   * WHY DELEGATED ON document: GF conditional logic hides/reshows fields and
   * re-renders on AJAX, which silently kills direct bindings. Delegation means
   * this needs no re-init from gform_post_render or gform_post_conditional_logic.
   *
   * CAVEAT -- this is COSMETIC, not validation. It shapes typing; it does not
   * stop a crafted POST. Anything that must not reach Zoho needs a server-side
   * `gform_field_validation` filter as well.
   *
   * NOTE on letters-only: the pattern deliberately allows spaces, hyphens,
   * apostrophes (both ' and the typographic one) and accented characters, so
   * O'Brien, Jean-Luc and Jos\u00e9 all still work. A naive /[^a-zA-Z]/ would break
   * legitimate names -- do not "simplify" it to that.
   *
   * Use on text / tel / textarea inputs. Do NOT use input-digits-only on a GF
   * Number field: number inputs report an empty value while partially invalid,
   * so there is nothing to sanitise. GF's Number type already restricts input
   * and validates server-side -- prefer it where it fits.
   *
   * NOTE on input-number-formatted: this is the permissive numeric filter -- it
   * blocks letters and symbols but does NOT enforce a valid number, so '1,,2..3'
   * and '1 2 3' both pass. That is deliberate: it accommodates thousands
   * separators, grouped digits, ranges ('10-20'), dimension strings ('4-6-8')
   * and negatives without fighting the user mid-typing. Hyphen position is NOT
   * constrained, so '--5-' passes too -- if a strictly parseable number is
   * required, use input-decimal-only, or add server-side validation.
   *
   * WARNING on postal codes: fields 202/203 are addressType 'international' and
   * the sub-input is labelled "ZIP / Postal Code". Restricting it to digits
   * BREAKS every non-US postal code -- Canada 'K1A 0B1', UK 'SW1A 1AA',
   * Netherlands '1012 AB'. Use input-postal-code (which blocks symbols but keeps
   * letters) unless the field is confirmed US-only, in which case
   * input-postal-digits is available. Do not reach for the digits variant just
   * because a ticket says "zip shouldn't accept letters". */

  var INPUT_FILTER_PATTERNS = {
    'input-digits-only':      /[^0-9]/g,
    'input-number-formatted': /[^0-9,.\s\-]/g,
    'input-letters-only':     /[^\p{L}\p{M}\s'\u2019.\-]/gu,
  };

  /* Sub-input scoped filters. `container` is matched with closest() against the
   * input, so only that one sub-input of a composite field is affected.
   * NOTE: '.address_zip' is Gravity Forms' own wrapper class for the ZIP /
   * Postal Code sub-input -- verify in devtools if GF markup ever changes. */
  var INPUT_SUBFIELD_FILTERS = {
    'input-postal-code':   { container: '.address_zip', pattern: /[^0-9A-Za-z\s\-]/g },
    'input-postal-digits': { container: '.address_zip', pattern: /[^0-9\-]/g },
  };

  function makeInputFilter( cls ) {
    if ( 'input-decimal-only' === cls ) {
      return function ( s ) {
        s = s.replace( /[^0-9.]/g, '' );
        var i = s.indexOf( '.' );
        // Keep the first decimal point, drop any later ones.
        return ( -1 === i ) ? s : s.slice( 0, i + 1 ) + s.slice( i + 1 ).replace( /\./g, '' );
      };
    }
    var re = INPUT_FILTER_PATTERNS[ cls ];
    return function ( s ) {
      return s.replace( re, '' );
    };
  }

  /* Rewrites el.value through `filter`, preserving caret position. Rewriting
   * .value normally throws the caret to the end, which makes editing mid-string
   * unusable, so the text before the caret is re-filtered to find where it
   * should land. */
  function applyFilterToInput( el, filter ) {
    var before = el.value;
    var clean  = filter( before );

    if ( clean === before ) return; // nothing stripped, leave the caret alone

    var caret = ( null === el.selectionStart ) ? clean.length : el.selectionStart;
    var newCaret = filter( before.slice( 0, caret ) ).length;

    el.value = clean;
    try {
      el.setSelectionRange( newCaret, newCaret );
    } catch ( e ) {
      // Some input types disallow setSelectionRange; the value is still correct.
    }
  }

  function applyInputFilter( el ) {
    var field = el.closest( '.gfield' );
    if ( ! field ) return;

    // Sub-input scoped filters first. If the field carries one of these classes,
    // ONLY the named sub-input is filtered -- every other sub-input (street,
    // city) is left completely alone.
    for ( var subCls in INPUT_SUBFIELD_FILTERS ) {
      if ( ! field.classList.contains( subCls ) ) continue;
      var spec = INPUT_SUBFIELD_FILTERS[ subCls ];
      if ( ! el.closest( spec.container ) ) continue;
      return applyFilterToInput( el, function ( s ) {
        return s.replace( spec.pattern, '' );
      } );
    }

    var cls = null;
    if ( field.classList.contains( 'input-digits-only' ) )           cls = 'input-digits-only';
    else if ( field.classList.contains( 'input-decimal-only' ) )     cls = 'input-decimal-only';
    else if ( field.classList.contains( 'input-number-formatted' ) ) cls = 'input-number-formatted';
    else if ( field.classList.contains( 'input-letters-only' ) )     cls = 'input-letters-only';
    if ( ! cls ) return;

    applyFilterToInput( el, makeInputFilter( cls ) );
  }

  $( document ).on(
    'input.inputFilters',
    '.gfield input[type="text"], .gfield input[type="tel"], .gfield textarea',
    function () {
      applyInputFilter( this );
    }
  );


  $( document ).on( 'gform_post_conditional_logic', function() {
      updateSectionVisibility();
      pruneOrphanedMultiStops( document );
      initUnitToggle( document );
      initCharterPayloadUnits( document );
      initPassengerPayloadCalc( document );
  } );

  /**
   * Service Path Mirror
   *
   * Field 2 ("What service do you need?") carries a choice value containing an
   * ampersand -- "Private & Commercial Jet Solutions". GF stores choice values
   * HTML-encoded but writes conditional logic rule values plain, so that choice
   * is not selectable in the conditional logic value dropdown: the stored plain
   * string matches no option and the select silently falls back to the first
   * choice. Saving that panel rewrites the rule to "Cargo Transport".
   *
   * Field 2's value cannot change -- it is what the feed sends to Zoho's
   * Service_Type picklist, and the PHP branch gates in gravity-forms-settings.php
   * compare against it. So a hidden mirror radio (field 218, class
   * .service-path-mirror) carries the same three paths under ampersand-free
   * values (cargo / jet / customs). Build new conditional logic against the
   * mirror; leave field 2 and its existing 111 rules alone.
   *
   * The mirror is display:none in CSS, NOT hidden by GF conditional logic -- GF
   * must keep evaluating it. It is never mapped in the Zoho feed.
   */

  var SERVICE_PATH_MAP = {
      'Cargo Transport':                    'cargo',
      'Private & Commercial Jet Solutions': 'jet',
      'Customs Brokerage':                  'customs'
  };

  function syncServicePath( $form ) {
      var $source = $form.find( '.service-type-field input[type="radio"]' );
      var $mirror = $form.find( '.service-path-mirror input[type="radio"]' );

      if ( ! $source.length || ! $mirror.length ) return;

      var $checked = $source.filter( ':checked' );

      // input.value comes back HTML-DECODED from the DOM, so the map key uses a
      // plain '&'. An encoded '&amp;' key would never match. Same trap as the
      // rgpost() comparisons on the PHP side.
      var target = $checked.length ? SERVICE_PATH_MAP[ $checked.val() ] : '';

      if ( $checked.length && undefined === target ) {
          // Field 2's choices changed without this map being updated. Leave the
          // mirror where it is rather than blanking it and collapsing the branch.
          if ( window.console && console.warn ) {
              console.warn( 'Service Path mirror: unmapped Service Type value', $checked.val() );
          }
          return;
      }

      var $want = target ? $mirror.filter( '[value="' + target + '"]' ) : $();

      // Bail if already in sync. Firing change unnecessarily makes GF re-evaluate
      // conditional logic across the whole form on every source change.
      if ( $want.length && $want.prop( 'checked' ) ) return;
      if ( ! $want.length && ! $mirror.filter( ':checked' ).length ) return;

      $mirror.prop( 'checked', false );
      if ( $want.length ) $want.prop( 'checked', true );

      // Must be a jQuery trigger -- GF's conditional logic listener is delegated
      // through jQuery and a native dispatchEvent() will not reach it.
      ( $want.length ? $want : $mirror.first() ).trigger( 'change' );
  }

  function initServicePathMirror( context ) {
      context = context || document;

      var $forms = $( context )
          .find( 'form[id^="gform_"]' )
          .addBack( 'form[id^="gform_"]' );

      if ( ! $forms.length ) return;

      $forms.each( function() {
          var $form = $( this );

          $form
              .off( 'change.servicePath' )
              .on( 'change.servicePath', '.service-type-field input[type="radio"]', function() {
                  syncServicePath( $form );
              } );

          // Sync on init so a prefilled selection, or one restored after a failed
          // validation pass, is mirrored before GF's first conditional logic run.
          syncServicePath( $form );
      } );
  }


  /**
   * Enter Key Submit Guard
   *
   * Browsers implicitly submit a form when Enter is pressed in a single-line
   * input, and this form has a single Submit button serving every Service Type
   * section — so Enter anywhere fires a full validation pass mid-typing.
   * Swallow Enter on single-line inputs and selects. Textareas, buttons and the
   * Google Places component keep native behaviour.
   */

  function initEnterKeyGuard( context ) {
      context = context || document;

      var $forms = $( context )
          .find( 'form[id^="gform_"]' )
          .addBack( 'form[id^="gform_"]' );

      if ( ! $forms.length ) return;

      $forms
          .off( 'keydown.enterguard' )
          .on( 'keydown.enterguard', function( e ) {
              if ( e.key !== 'Enter' ) return;

              var el  = e.target;
              var tag = el && el.tagName;

              if ( tag !== 'INPUT' && tag !== 'SELECT' ) return;

              if ( tag === 'INPUT' ) {
                  // Radios and checkboxes toggle on Space, not Enter — Enter on
                  // them does nothing but submit, so they need the guard too.
                  var type = ( el.type || '' ).toLowerCase();
                  if ( type === 'submit' || type === 'button' ||
                       type === 'image'  || type === 'reset'  ||
                       type === 'file' ) return;
              }

              // Enter inside Google Places autocomplete selects a prediction.
              if ( el.closest( 'gmp-place-autocomplete' ) ) return;

              // GF enhanced-UI selects use Enter to choose an option.
              if ( el.closest( '.chosen-container' ) ) return;

              e.preventDefault();
          } );
  }


  document.addEventListener( 'DOMContentLoaded', function() {
    initCharterCards();
    initNumberSteppers();
    initPassengerPayloadCalc( document );
    initCharterPayloadUnits( document );
    initDimensionFieldsWrap( document );
    initWeightVolumeWrap( document );
    initItemCountPlusWeightWrap( document );
    initTwoColLayout( document );
    initUnitToggle( document );
    initFreightItemSystem( document );
    initMultiStopSystem( document );
    initCustomsItemSystem( document );
    initServicePathMirror( document );
    updateSectionVisibility();
    watchPlacesAutocomplete();
    formPageStripAnchor();
    initEnterKeyGuard( document );
  } );

  document.addEventListener( 'gform_post_render', function( e ) {
    initCharterCards( e.target );
    initNumberSteppers( e.target );
    initPassengerPayloadCalc( e.target );
    initCharterPayloadUnits( e.target );
    initDimensionFieldsWrap( e.target );
    initWeightVolumeWrap( e.target );
    initItemCountPlusWeightWrap( e.target );
    initTwoColLayout( e.target );
    initUnitToggle( e.target );
    initFreightItemSystem( e.target );
    initMultiStopSystem( e.target );
    initCustomsItemSystem( e.target );
    initServicePathMirror( e.target );
    updateSectionVisibility();
    initPlacesAutocomplete( e.target );
    formPageResetScroll();
    initEnterKeyGuard( e.target );
  } );


  // Gravity Form radios, rendering breaks on radio labels where there's a /

  document.querySelectorAll('.gform-theme--framework .gfield--type-choice.field_description_above.priority-type-field .ginput_container .gfield_radio .gchoice .icon-plus-text span').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/\//g, '/<wbr>');
  });




})(jQuery);
